//Español
export const language = {
    meassage:{
        leanMore:'Más informaciones',
        skip:'Omitir',
        activate:'Activar',
        emailSend: 'Email sent!',
        },
leftBanner: {
    liteFile: 'Lite File',
    logoSlogan: 'Líder en transferencias entre nubes',
    cloudEscription: 'MultCloud – La solución de confianza para transferencias en la nube',
    commonTools: 'Herramientas Comunes',
    cloudDrives: 'Mi Cloud',
    onlineServices: 'Mis Servicios en Línea',
    inviteFriends: 'invitar a amigos',
    taskList: 'Lista de Tareas',
    cloudTransfer: 'Transferencia de Cloud',
    cloudSync: 'Sincronización de Cloud',
    cloudBackup:'Respaldo en la nube',
    btLink: 'Descarga Offline',
    teamTransfer:'Transferencia de Equipos',
    shares: 'Compartimiento',
    emailTransfer: 'Migración de Email',
    instagramDownload: 'Descargador de Instagram',
    videoDownload: 'Descargador de Videos',
    webDownload: 'Descargador de imágenes',
    addCloud: 'Add Cloud',
    addEmail: 'Add Email',
    encryption: 'Cifrar',
    edit: 'Agregar de nuevo',
    remove: 'Eliminar',
    createTask: 'Crear Tarea',
    createTaskText: 'Puede crear las tareas más comunes aquí.',
    gotIt: 'Entiendo',
    bigWriteEncrypt: 'Cifrar',
    encryptionText: 'Puede configurar el cifrado de archivos en la nube aquí.',
    addCloudText: 'Haga clic aquí para conectar su unidad en la nube y su correo electrónico a MultCloud.',
    switchTxt: 'Cambiar al clásico MultCloud',
    inviteFriends: 'Invitar a amigos',
    switchTip:'Cambiar al clásico MultCloud',
    switchTipDes:'Puede cambiar al clásico MultCloud aquí.',
    new: 'Nuevo',
},
common: {
    addCloud: 'Añadir Cloud',
    addEmail: 'Añadir Email',
    options: 'Opciones',
    schedule: 'Programación',
    ok: 'OK',
    save: 'Conservar',
    add: 'Añadir',
    upgradeNow: 'Actualizar Ahora',
    from: 'Desde',
    to: 'A',
    result: 'Resultado',
    fileProcess: 'Progreso del Archivo',
    transferFiles:'Archivos',
    dataProcess: 'Progreso de Datos',
    startTime: 'Hora de Inicio',
    currentRate: 'Tasa Actual',
    endTime: 'Hora de Finalización',
    timeRemaining: 'Tiempo Restante',
    averageRate: 'Tasa Promedio',
    averageRateSpecial: 'Avg.Rate',
    viewFailed: 'haga clic para ver los archivos fallidos',
    fileSuccess: 'Transferir todos los archivos con éxito',
    size: 'Tamaño',
    executedTimes: 'Tiempos ejecutados',
    sourceDir: 'Directorio de Origen',
    cause: 'Razón',
    retry: 'Reintentar',
    retryMin: 'Intentar otra vez',
    clean: 'Limpiar',
    properties: 'Propiedades',
    copy: 'Copiar',
    move: 'Mover',
    multiSelect: 'Selección Múltiple',
    close: 'Apagar',
    copyTo: 'Copiar a',
    tranTo: 'Transferir a',
    syncWith: 'Sincronizar con',
    backupTo: 'Hacer copia de seguridad en',
    download: 'Descargar',
    delete: 'Eliminar',
    more: 'Más',
    preview: 'Previsualizar',
    share: 'Compartir',
    shareWith: 'Compartir con MultCloud',
    shareTransfer: 'Crear una transferencia',
    encrypt: 'Cifrar',
    encryptFile: 'Cifrar Archivo Solamente',
    encryptFileName: 'Cifrar Archivo y Nombre',
    decrypt: 'Descifrar',
    decryptFile: 'Descifrar Archivo Solamente',
    decryptFileName: 'Descifrar Archivo y Nombre',
    onedriveBusinessContentNote: 'Nota',
    oneDrive4BusinessContent: 'Si eres administrador y has asignado una licencia de Microsoft 365 a un usuario pero recibes un error de "Acceso denegado" al intentar acceder a la carpeta del usuario a través de MultCloud, prueba los siguientes pasos:',
    oneDrive4BusinessTips1: `Vaya a "<a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>Admin</a>". Seleccione la pestaña "Usuarios" > "Usuarios activos" > Seleccione la opción "Gestionar licencia de producto".`,
    oneDrive4BusinessTips2: 'Ve a la pestaña "OneDrive" y haz clic en "Crear enlace a archivo". A continuación, vuelve a MultCloud e intenta acceder de nuevo a la cuenta.',
    oneDrive4BusinessStep1: 'Paso 1',
    oneDrive4BusinessStep2: 'Paso 2',
    upStep: 'Anterior',
    nextStep: 'Siguiente',
    complete: 'Terminar',
    cut: 'Cortar',
    viewDetails: 'Ver Detalles',
    toOfficialSite: 'Sitio Oficial',
    btLinkTask: 'Tarea Offline',
    fileName: 'Nombre del Archivo',
    itemsSelected: 'elementos seleccionados',
    dateModified: 'Fecha de Modificación',
    rename: 'Rebautizar',
    paste: 'Pegar',
    btLink: 'Descarga Offline',
    load: 'Cargando',
    status: 'Estado',
    operate: 'Funcionar',
    failure: 'Fracaso',
    link: 'Enlace',
    cleanList: 'Limpiar Lista',
    type: 'Tipo',
    account: 'Cuenta',
    name: 'Nombre',
    selectFailedFile: 'Seleccione el archivo fallido',
    transferring: 'Transfiriendo',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    done: 'Finalizado',
    no: 'No',
    yes: 'Sí',
    attention: 'Cuidado',
    cancel: 'Cancelar',
    unsubscribe: 'Cancelar suscripción',
    reactivate: 'Reactívalo',
    sureCleanAll: '¿Está seguro de eliminar todas las tareas completadas?',
    failedFiles: 'Archivos Fallidos',
    minTo: 'a',
    retryAll: 'Intentar otra vez',
    viewProgress: 'Ver Progreso',
    taskNotRun: 'Esta tarea no se está ejecutando.',
    success: 'Éxito',
    canceled: 'Cancelado',
    patial: 'Éxito Parcial',
    syncDetails: 'Detalles de Sincronización',
    width: 'Anchura',
    sync: 'Sincronizar',
    targetCloud: 'Destino de Cloud Drives',
    running: 'Corriendo',
    preparing: 'Preparando',
    waiting: 'Esperando',
    target: 'Destino',
    noVip: 'Ahora tiene un máximo de 2 archivos transfiriéndose simultáneamente. ¡Actualice a cualquier servicio premium para tener un máximo de 10!',
    vipThanks: 'Gracias por suscribirte a nuestro servicio. Ahora tiene un máximo de 10 archivos que se transfieren simultáneamente.',
    emailAccount: 'Cuenta de Email',
    with: 'Con',
    syncing: 'Sincronizando',
    selectAll: 'Seleccionar Todo',
    date: 'Fecha',
    failed: 'Fallido',
    skip: 'Omitir',
    replace: 'Reemplazar',
    ready: 'Listo',
    connecting: 'Conectando',
    account: 'Cuenta',
    selectNull: 'Seleccione un directorio de destino.',
    selectOther: 'Este directorio no se puede seleccionar para pegar archivos, puede seleccionar sus subdirectorios u otros directorios.',
    //2020-8-18-xth新增
    editShare: 'Editar Compartir',
    toSource: 'A la Fuente',
    copyLink: 'Copiar Enlace',
    toShare: 'A Compartir',
    report: 'Reporte',
    expand: 'Extender',
    shrink: 'Reducir',
    // userExpired: 'La información del usuario ha caducado, actualice la página.'
    //2020-10-26-ljm新增
    filterHolder:'Introduzca una extensión de archivo aquí, por ejemplo, mp4.',
    countFiles:'Contando archivos',
      //2020-12-2-ljm新增
    upgradeMulti:'Aggiorna a Multithreading',
    team: "Archivos de Equipo",
    loadData:"Cargando datos, espere",
    loadingData:'Cargando datos ...',
    failedEmptyTip: 'No se han podido cargar los archivos. Póngase en contacto con <a href="mailto:support@multcloud.com">support@multcloud.com</a> para obtener más ayuda.',
    runNow:'Ejecutar Ahora',
    emailFilter: 'Filtro de correo electrónico',
    me: "A mí",
    reset: "Restablecer",
    apply: "Aplicar",
    failureReason: 'Razón de la falla',
    countingFilesTip: 'Calculando ({num} archivos)',
    taskName: 'Nombre de la tarea',
    frequency: 'Frecuencia:',
    canceling: 'Cancelando...',
},
rightTopBanner: {
    navTransfer: 'Transferencia de nube a nube',
    navInstagram: 'Descargador de Instagram',
    navVideo: 'Descargador de Videos',
    navWeb: 'Descargador de imágenes',
    traffic: 'Tráfico',
    upgrade: 'Actualizar',
    settings: 'Configuraciones',
    changePassword: 'Cambia la Contraseña',
    changeName: 'Cambiar Nombre',
    bindEmail: 'Enlazar Email',
    deleteAccount: 'Borrar Cuenta',
    language: 'Idioma',
    help: 'Ayuda',
    notifications: 'Notificaciones',
    notification: 'Notificación',
    subAccounts: 'Subcuentas',
    logout: 'Cerrar Sesión',
    tutorials: 'Tutoriales',
    contact: 'Contacto',
    limitsClouds: 'Límites de Clouds',
    faq: 'FAQ',
    purTraffic: 'Compra Tráfico',
    unlimitedPlan: 'Plan Ilimitado',
    monthlyUnlimitedPlan: 'Plan Ilimitado Mensual',
    rememberOriginal: 'Recuerde su nombre de usuario original:',
    andPassword: 'y contraseña',
    bindEmailOpen: 'Es mejor <span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">enlazar su dirección de correo electrónico y cambiar la contraseña predeterminada </span> por seguridad y conveniencia.',
    lifeSwitchTip: 'Con el servicio Ilimitado de por Vida, puede transferir archivos entre nubes sin límites de tráfico.',
    lifeTimePlan: 'Ilimitado de por Vida',
    browserPrompt:'Para una mejor experiencia de usuario, le sugerimos que utilice Google Chrome.',
    unlimited:'Ilimitado',
    lifeTimeNotice:'Usted es usuario de MultCloud Plan Ilimitado de por Vida.',
    subAccount:"Sub-cuenta",
    bindMailTips:"Por favor, enlaza tu correo electrónico para desbloquear la transferencia de archivos en la nube y sacar el máximo provecho de MultCloud.",
    bind:"Enlazar",
},
popup: {
    userStarPopup: {
        starDesc: "¿Qué tal su experiencia hasta ahora?",
        ok: "Vale",
        thankYou: "Muchas gracias.",
        thankYouDesc: "Si pudieras dedicar un momento a compartir tu experiencia real y sincera utilizando nuestro producto, ayudarías a mantener motivado a nuestro pequeño equipo para hacer que MultCloud sea aún mejor.",
        reviewStart: "Valórenos en",
        reviewEnd: "",
        feedbackTitle: "¿Cómo podemos mejorar?",
        feedbackDesc: "Añade tu opinión",
        feedbackBtn: "Enviar",
        feedbackYes: "Gracias por sus comentarios.",
        feedbackNo: "Por favor, introduce tus comentarios.",
    },
    addCloudPopup: {
        endpointOptional:'Punto final (opcional)',
        //2020.09.23 添加NAS云盘
        addNas: 'AÑADIR NAS',
        addNasFtpDes: `Conecte el NAS a través de FTP. ¿No sabe cómo configurar FTP para NAS? <a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>Haga clic aquí</a>`,
        addNasWebDes: `Conecte NAS a través de WebDAV. ¿No sabe cómo configurar WebDAV para NAS? <a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>Haga clic aquí</a>`,
        //
        bucketName: 'Nombre del Bucket',
        accessKeyId: 'ID de Clave de Acceso',
        idriveKeyId: 'Access Key ID',
        endpoint: 'Endpoint',
        secretAccessKey: 'Clave de Acceso Secreta',
        idriveSecretAccessKey: 'Secret Access Key',
        displayName: 'Muestra Nombre',
        addFtp: 'AÑADIR FTP',
        addFtpDes: 'Para conectarse su FTP,MultCloud necesita que introduzca sus datos de autenticación.',
        egnyteTip: `Consejo: Para obtener su clave y secreto, necesitará el ID de gestión de la API de Egnyte. Si no tiene uno, puede <a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>registrarse aquí</a>.`,
        icedriveTip: 'Nota:',
        icedriveTip1: '1. Solo admite cuentas Premium de Icedrive.',
        icedriveTip2:`2. Haga clic en su nombre de usuario Icedrive -> 2FA & Access -> WebDAV -> Habilitar -> Mostrar clave. La Clave de Acceso es la contraseña.`,
        iCloudPhotosTip: 'Consejos:',
        iCloudPhotosTip1: '1. Antes de conectar tus Fotos de iCloud a MultCloud, asegúrate de que la opción "Acceder a los datos de iCloud en la web" está activada.',
        iCloudPhotosTip1Q: `Cómo gestionar el acceso web a tus datos de iCloud：<br><br>En iPhone o iPad<br>1. Abre la aplicación Ajustes.<br>2. Pulsa tu nombre y, a continuación, pulsa iCloud.<br><br>3. Toca para desactivar o activar Acceder a los datos de iCloud en la Web.<br>
        <br>En Mac<br>1. Seleccione el menú Apple > Ajustes del sistema.<br>2. Haz clic en tu nombre y, a continuación, en iCloud.<br>3. Haz clic para desactivar o activar Acceder a los datos de iCloud en la web.`,
        iCloudPhotosTip2: '2. Fotos de iCloud solo admite los siguientes formatos de imagen: jfif, pjpeg, jpeg, pjp, jpg, HEIC.',
        server: 'servidor',
        protocol: 'Protocolo',
        port: 'Puerto',
        passive: 'Modo pasivo',
        passphrase: 'Frase de contraseña',
        explanation: 'Para conectarse a FTP, el prefijo debe ser "ftp://" o se pierde el prefijo.Si su puerto FTP no es el predeterminado, es un número de puerto especial, como 21,utilice el formato para especificar el puerto a continuación:ftp://ftp.myhost.com:21',
        userName: 'Nombre de Usuario',
        passWord: 'Contraseña',
        advanced: 'Avanzado',
        commFTP: 'FTP Común',
        transMode: 'Modo de transferencia',
        encoding: 'Codificación',
        path: 'Ruta(opcional)',
        cloudName: 'Nombre de Cloud',
        cloudService: 'Servicio de Cloud',
        addedTime: 'Tiempo Añadido',
        usedSpace: 'Espacio Usado',
        totalSpace: 'Espacio Total',
        iCloudUsedSpace: 'Almacenamiento de Fotos en iCloud',
        iCloudDriveUsedSpace: 'Almacenamiento de iCloud Drive',
        iCloudTotalSpace: 'Almacenamiento total en iCloud',
        iCloudDriveTotalSpace: 'Almacenamiento total en iCloud',
        removeContent: 'Algunas tareas de transferencia a cloud se basan en esta cloud. ¿Aún quieres eliminarlo?',
        baiDuTips: 'Sólo puedes subir o transferir archivos al directorio de "全部文件/我的应用数据/MultCloud"',
        google_driveTips: 'Cuando transfiera archivos o carpetas de Google Drive a otro, asegúrese de que no haya los mismos nombres de archivo en el mismo directorio.',
        mySQLQuestion: 'Debe ingresar su dirección IP del servidor MySQL en el campo del servidor, y el puerto predeterminado es 3306 o debe ingresar su puerto personalizado.',
        webDavQuestion: `Si usa una conexión SSL segura, agregue "https://" prefijo a su host o no haga nada y el puerto predeterminado es 443; de lo contrario, el prefijo debe ser "http://" y el puerto predeterminado es 80.
        p.ej. https://dav.box.com/dav`,
        egnyteQuestion: 'Inicie sesión en Egnyte y busque su dominio en la barra de direcciones. Ingrese el dominio en este formato: p.ej. https://aomeitech.egnyte.com/',
        ownCloudQuestion: 'Si usa una conexión SSL segura, agregue "https://" prefijo a su host o no haga nada y el puerto predeterminado es 443; de lo contrario, el prefijo debe ser "http://" y el puerto predeterminado es 80',
        amazonQuestion: `Visite la página para aprender <a href="https://www.multcloud.com/tutorials/s3-key.html" target="_blank" class='add-cloud-link'>cómo obtener la identificación de la clave de acceso de Amazon S3.</a>`,
        boxTips: `Box no admite la transmisión de un solo archivo de más de 2GB.`,
        google_drive_sharedWithMeTips:'Cuando transfiera archivos a las carpetas de Shared With Me drive, asegúrese de estar autorizado con "Permiso de carga".',
                   gSuiteSharedDriveTips:'Cuando transfiera archivos a las carpetas de Shared Drive, asegúrese de que está autorizado con "Permiso de carga".',
        webDavTips: `1.Asegúrese de tener permisos de lectura/escritura antes de las operaciones con archivos; de lo contrario, es posible que MultCloud no pueda transferir archivos a su WebDav.
        2. Asegúrese de que haya suficiente espacio para sus operaciones. No podemos identificar temporalmente su tamaño.`,
        aDriveTips: 'Actualmente, admitimos cuentas Personal Prima y Empresarial, pero no cuentas Básico Personal.',
        yandexTips: `1.Asegúrese de que haya suficiente espacio para sus operaciones. No podemos identificar temporalmente su tamaño.
                     2.Si ha habilitado la contraseña de la aplicación, introduzca la contraseña de la aplicación en la barra de contraseñas de arriba.`,
        googlePhotosTips: `1.El directorio "Photos" solo puede almacenar imágenes, videos y otros archivos multimedia, pero no directorios.
        2.El directorio "Albums" solo puede almacenar directorios de álbumes, pero no archivos multimedia.
        3.El directorio "Sharing" contiene todos los álbumes compartidos por usted o los álbumes compartidos a los que se ha unido.
        4.Google Photos solo admite la carga de imágenes, videos y otros archivos multimedia. Y al usar la función de carga de MultCloud, solo puede cargar archivos en los directorios de álbumes creados o compartidos por MultCloud.
        5.Al utilizar la función de compartir fuente de MultCloud, solo puede compartir los álbumes creados por MultCloud.
        6.Todos los álbumes sin título se mostrarán como "Untitled".
        7.Actualmente, la función de descarga está disponible, pero no se admite la descarga de archivos originales.
        8.Actualmente, no hay soporte para las funciones de cortar, borrar y renombrar. Y no puede utilizar las funciones que dependen de estas operaciones.`,
        googlePhotosV2Tips: `1.El directorio "Photos" solo puede almacenar imágenes, videos y otros archivos multimedia, pero no directorios.
        2.El directorio "Albums" solo puede almacenar directorios de álbumes, pero no archivos multimedia.`,
        evernoteTips: `1. Límites de tasa de API. <a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'> Ver detalles>> </a>
          2. ¿Cuáles son los límites del sistema de Evernote? <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target="_blank" class='add-cloud-link'>Ver detalles>></a>
          3. Solo puede cargar un archivo de menos de 50MB en la nota.
          4. No se pueden cambiar el nombre o eliminar los archivos de contenido de notas (. ENML).
          5. Solo se pueden copiar las notas al cuaderno.`,
        flickrTips: `1. Solo puede transferir imágenes o videos a Flickr.
        2. Las carpetas solo se pueden transferir al directorio "Albums" y no puede haber subdirectorios en el directorio "Albums".
        3. Los archivos solo se pueden transferir al directorio "My Photostream" o "Albums" que cree.
        4. Todos sus archivos se pueden encontrar en el directorio "My Photostream".
        5. Todos los archivos del directorio "Albums" se referencian al directorio "My Photostream".`,
        mediafireTips: 'No se admite la carga y descarga de archivos vacíos. Puede llevar mucho tiempo abrir una carpeta que contenga muchos archivos.',
        mySQLTips: `1. Su base de datos debe ser accesible desde nuestras direcciones IP, que son 209.126.%. Puede crear un nuevo usuario a través de su base de datos o interfaz de host, el comando MySQL es el siguiente:
        <span class='add-mysql-link'>GRANT SHOW DATABASES, SELECT, LOCK TABLES, RELOAD ON *.* TO username@'209.126.%' IDENTIFIED BY 'password'</span>;
        2. Es posible que su servidor necesite agregar una regla de firewall con nuestras direcciones IP y puerto de acceso (el puerto predeterminado es 3306) para acceder a sus bases de datos normalmente.`,
        hubiCTips: `1. Una cuenta hubiC solo se puede agregar una vez.
        2. No puede cambiar el nombre y cortar archivos o carpetas.
        3. Puede resultar un poco lento eliminar carpetas con muchos archivos.
        4. hubiC no admite la transmisión de un solo archivo de más de 5GB.
        5. Los nombres de archivo no pueden superar los 248 caracteres y los nombres de las carpetas están limitados a 256 caracteres.`,
        gSuiteUpTips: `La conexión entre G Suite y MultCloud solo está disponible para administradores de G Suite. Para conectar G Suite a MultCloud, debe "INSTALAR DOMINIO" nuestro G Suite Marketplace app --- <a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'>"Cloud Transfer - MultCloud"</a> first.`,
        gSuiteTips: `1.Debe ser un <a href="https://support.google.com/a/answer/2405986?hl=en" target="_blank" class='add-cloud-link'> administrador de G Suite</a>.
                    2.¿Cómo comprobar si es una cuenta de administrador? Primero, consulte este enlace <a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google.com/a/answer/2406043</a>. Segundo, inicie sesión en su cuenta de Gsuite desde el enlace. Tercero, puede encontrar los resultados en la línea "To create a custom role".
                        3.El <a href='https://support.google.com/a/answer/60757?hl=en' target="_blank" class='add-cloud-link'>API Access </a> debe estar habilitado.
                    4.Antes de agregar esta unidad en la nube, debe instalar nuestro <a href='https://gsuite.google.com/marketplace?hl=en' target="_blank" class='add-cloud-link'> G Suite Marketplace app </a> "MultCloud para G Suite" primero y asegúrese de que sea <a href='https://admin.google.com/' target="_blank" class='add-cloud-link'> configuración </a>  es correcto: el estado es encendido y se concede el acceso a los datos.`,
        hiDriveTips: `1.Por favor, asegúrate de que tienes una cuenta con el protocolo WebDAV activado y permisos de lectura/escritura antes de trabajar con archivos, de lo contrario MultCloud podría no ser capaz de transferir archivos a tu HiDrive.
        2. Asegúrese de que haya suficiente espacio para sus operaciones. No podemos identificar temporalmente su tamaño.`,
        backblazeTips: `1.Cada nombre de depósito debe tener al menos 6 caracteres.
        2.Cuando crea una nueva clave de aplicación, la anterior ya no funcionará.
        3.Los nombres de archivo no pueden comenzar con "/", terminar con "/", o contener "//".`,
        WEBDETips: `1.Asegúrese de tener permisos de lectura/escritura antes de las operaciones con archivos; de lo contrario, es posible que MultCloud no pueda transferir archivos a su Web.De.
        2. Asegúrese de que haya suficiente espacio para sus operaciones. No podemos identificar temporalmente su tamaño.`,
        alfrescoTips: `Como cuenta gratuita de Alfresco, su espacio de almacenamiento para la red es de 10GB y el límite de tamaño de archivo individual es de 50MB.`,
        cloudMeTips: `1.Asegúrese de tener permisos de lectura/escritura antes de las operaciones con archivos; de lo contrario, es posible que MultCloud no pueda transferir archivos a su CloudMe.
        2. Asegúrese de que haya suficiente espacio para sus operaciones. No podemos identificar temporalmente su tamaño.`,
        myDriveTips: `Asegúrese de que haya suficiente espacio para sus operaciones. No podemos identificar temporalmente su tamaño.`,
        cubbyTips: `1.Asegúrese de tener permisos de lectura/escritura antes de las operaciones con archivos; de lo contrario, es posible que MultCloud no pueda transferir archivos a su Cubby.
        2. Asegúrese de que haya suficiente espacio para sus operaciones. No podemos identificar temporalmente su tamaño.`,
        cloudType: 'Tipo de Cloud',
        notificationTip: `Gracias por usar la última MultCloud, si tiene algún problema, envíe sus comentarios a:<a href="mailto:support@multcloud.com">support@multcloud.com</a>,gracias.`,
        notAbleAccess: 'Resuelto:No puedo acceder a Google Photos',
        problemNotAccess: 'Se solucionó el problema de no poder acceder a Google Photos. Si aún no puede acceder a Google Photos, vuelva a agregarlo a MultCloud.',
        noPrompt: 'No avisar la próxima vez',
        addFeatures: 'Algunas características nuevas agregadas a continuación',
        version: 'Versión:',
        applicationKey: 'clave de aplicación',
        keyID: 'keyID',
        privateKey: 'Archivo de clave privada para autenticación (opcional)',
        FTPTips:`1.Asegúrese de tener permisos de lectura / escritura antes de las operaciones con archivos; de lo contrario, es posible que MultCloud no pueda transferir archivos a su FTP.
        2. Asegúrese de que haya suficiente espacio para sus operaciones. No podemos identificar temporalmente su tamaño.
        3. Si no puede acceder a su FTP, agregue 209.126.103.1/19 y 207.38.89.1/24 a la lista blanca del firewall.`,
        specialDropBox:`Si es un administrador de Dropbox Business y desea acceder a todas las cuentas de su organización, haga clic en "Acceder a la Organización".`,
        specialDropBoxBottom:`Si quiere acceder a su nube personal, haga clic en "Acceder a la Vube Personal".`,
        accessOrganization:'Acceder a la Organización',
        accessPersonalCloud:'Acceder a la Nube Personal',
        specialBoxBusiness:`Si es un administrador de box for Business y desea acceder a todas las cuentas de su organización, haga clic en "Acceder a la organización".`,
        specialgSuite:`Si es un <a href='https://support.google.com/a/answer/2405986?hl=es' target="_blank" class='add-cloud-link'> Administrador de Google Workspace </a> y quiere acceder a todas las cuentas de su organización, por favor "INSTALE EL DOMINIO" de nuestra aplicación G Suite Marketplace --- "<a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=es" target="_blank" class='add-cloud-link'>Cloud Transfer – MultCloud</a>" primero. Y luego haga clic en "Acceder a la Organización".`,
        specialOnedrive:`Si es un administrador de OneDrive for Business y desea acceder a todas las cuentas de su organización, haga clic en "Acceder a la organización".`,
        iCloudPhotosTips:'MultCloud no admite por ahora el ID de Apple que no sea de correo electrónico.',
        appleId: 'ID de Apple',
        addICloudPhotos: 'Añadir iCloud Fotos',
        addICloudDrive: 'Añadir iCloud Drive',
        fourShared: `Nota: la autorización de 4shared es válida por<span style="color: red"> 2 horas. </span> Vuelva a agregar 4shared y ejecute manualmente sus tareas después de que caduque.`,
        fourSharedTips: `Nota: la autorización de 4shared es válida por 2 horas.  Vuelva a agregar 4shared y ejecute manualmente sus tareas después de que caduque.`,
    },
    cloudExploerPopup: {
        googlePhotosV2Tips: 'Consejos para Google Fotos',
        googlePhotosV2TipsDesc: 'Google ha actualizado la API de Google Fotos a partir del 7 de mayo de 2025. Para adaptarse a estos cambios, tiene que implementar las siguientes actualizaciones:',
        googlePhotosV2Tips1: 'La carpeta "Álbumes" ahora solo mostrará los álbumes creados a través de MultCloud.',
        googlePhotosV2Tips2: 'La carpeta "Fotos" ahora solo mostrará imágenes subidas a través de MultCloud.',
        googlePhotosV2Tips3: 'Para transferir imágenes de Google Fotos a otros servicios en la Nube, haz clic en el botón "Añadir más fotos" y concede acceso a MultCloud a las imágenes que desees transferir.',
        googlePhotosV2Tips4: 'Para transferir imágenes desde otros servicios en la nube a Google Fotos, ten en cuenta que solo se pueden transferir carpetas a la carpeta "Álbumes", mientras que a la carpeta "Fotos" solo es posible enviar imágenes individuales.',
        googlePhotosV2TipsShow: 'No volver a mostrar esto',
        googlePhotosV2AddMore: 'Añadir Más Fotos',
        googlePhotosV2AddMoreTips: 'Haz clic aquí para añadir las imágenes que quieras añadir a MultCloud.',
        googlePhotosV2FolderName: 'Nombre de Carpeta',
        googlePhotosV2FolderNameInput: 'Introduce un nombre para la carpeta donde se guardarán las imágenes.',
        googlePhotosV2NotSelect: 'Aún no has añadido ninguna foto. Haz clic en "Añadir más fotos" para añadir imágenes a MultCloud',
        googlePhotosV2SelectAlbums: 'Sólo puede guardar carpetas en "Álbumes"',
        googlePhotosV2SelectAlbum: 'Sólo puede guardar imágenes y vídeos en esta carpeta',
        googlePhotosV2SelectPhotos: 'Sólo puede guardar imágenes y vídeos en "Fotos"',
        googlePhotosV2SelectSession: 'Esta carpeta no puede seleccionarse como destino. Seleccione en su lugar la carpeta "Álbumes" o "Fotos".',
        deleteContentEver: '¿Está seguro de que desea eliminar los elementos seleccionados de forma permanente?<br>Una vez eliminado, no se puede restaurar desde la Papelera.',
        deleteContent: '¿Está seguro de que desea eliminar los elementos seleccionados?',
        detailedProgress: 'Progreso Detallado',
        highSpeed: 'La búsqueda de alta velocidad admite las siguientes unidades en la nube',
        takeMoreTime: 'Puede llevar más tiempo con las siguientes unidades cloud',
        enterKeyWord: 'Ingrese la palabra clave',
        highSpeedSearch: 'Búsqueda de alta velocidad',
        normalSearch: 'Búsqueda Normal',
        shareWithOthers: 'Compartir con otros',
        inviteByEmail: 'Invita personas con email',
        pleaseEnterEmail: 'Ingrese correos electrónicos y sepárelos con comas',
        addMessage: 'Agregar un mensaje (opcional)',
        shareTo: 'Compartir a',
        noLink: 'Aún no se ha creado ningún enlace',
        createShare: 'Crear Compartir',
        cancelAllTask: '¿Está seguro de que desea cancelar todas las tareas?',
        //2020/8/7-xth
        shareEmailTitle: 'Enviar enlace por Email',
        // shareCommunityTitleLong: 'El título debe tener menos de 128 caracteres',
        // shareCommunityDesLong: 'La descripción debe tener menos de 256 caracteres',
        shareNotSupportSource: 'Este servicio de cloud no admite esta función, pruebe con otra opción para compartir',
        shareSendEmail: 'Enviar Email',
        generateLinkSuccess: 'Enlace para compartir creado',
        generateLinkFail: 'No se pudo crear el enlace para compartir',
        emailSentSuccessful: 'Correos electrónicos enviados',
        emailSentNull: 'Aún no ha ingresado un Email',
        emailSentNotice: 'Ingrese un Email correcto',
        linkCopySuccessful: '¡Enlace copiado!',
        sharePrivateLink: 'Enlace para compartir privado: ',
        sharePrivatePassword: ' Ver contraseña: ',
        cancelMyShareTask: '¿Está seguro de cancelar la acción? Este enlace ya no funcionará para nadie que lo tenga.',
        cancelMyShareOk: 'Si, cancelarla',
        cancelMyShareNot: 'No, la mantendré',
        emailArrayToLong50: 'Puede enviar 50 correos electrónicos a la vez.',
        shareOnEmail: 'Enviar enlaces por E-mail',
        shareOnFacebook: 'Compartir por Facebook',
        shareOnTwitter: 'Compartir por Twitter',
        shareOnTumblr: 'Compartir por Tumblr',
        shareOnPinterest: 'Compartir por Pinterest',
        shareOnLinkedIn: 'Compartir por LinkedIn',
        ceateShareError: 'No se pudo crear el recurso compartido, verifique su red.'
    },
    cloudTransferPopup: {
        pleaSelect: 'Por favor seleccione',
        schedule: 'Programación',
        //后又新增的
        checkScheduled: 'Marque la casilla \'Programado\' de esta tarea para activar el editor de programación.',
        addValidCloud: 'Debe agregar una unidad en la nube válida',
         //2020-10-26-ljm增加
         cleanList:'Limpiar Lista'
    },
    personalCenter: {
        changePassword: ' Cambia la Contraseña',
        changeName: 'Cambiar Nombre',
        deleteAccount: ' Borrar Cuenta',
        enterPassWord: 'Introduzca su contraseña',
        note: 'Note: Háganos saber la razón por la que se va, haremos todo lo posible para corregirla.',
        sureDeleteAccount: '¿Está seguro de que quiere eliminar esta cuenta?',
        unsubscribe: 'Antes de eliminar esta cuenta, primero cancele la suscripción a MultCloud.',
        bindEmail: 'Enlazar Email',
        pleaseSwitch: 'Cambie al Clásico MultCloud para descifrar los archivos.',
        switchOld: 'Cambiar a clásico',
        pleaseUnsubscribe: 'Primero, cambie al Clásico MultCloud para cancelar la suscripción a su servicio premium.',
        deletePremium: 'Está a punto de eliminar una cuenta premium. Una vez que lo haya eliminado, nunca podría recuperarlo. ¿Está seguro de que todavía quiere hacer esto?'
    },
    remoteTaskPopup: {
        addLinkTask: ' Agregar Tarea de Enlace',
        validLink: 'Ingrese un enlace válido',
        saveCloud: 'Guardar en Cloud',
        parseFail:'no se pudo analizar',
        inadmissibleRequest:'Una solicitud inadmisible',
        createBtTask: 'Crear Tarea de BT',
        emptySource: 'Ingrese un enlace o cargue un archivo torrent',
        validTorrent: 'El archivo torrent seleccionado no es válido',
        addTorrent: 'Agregar Torrent',
        tip: ' No ha seleccionado un cloud para almacenar este archivo',
        torrentSelected:'Nombre({num}/{all})',
        urlLinkSupported:"Copie y pegue el enlace aquí, se admiten enlaces http/https/magnet.\nNota: No utilice MultCloud para descargar o cargar materiales copiados infractores no autorizados.",
        torrentStore:'Seleccione una nube para almacenar el archivo torrent',
        downloadLink:'Introduzca un enlace de descarga.',
        cancelTask:'Cancelar Tarea',
        cancelTaskContent:'¿Está seguro de que desea cancelar la tarea?',
		parseTaskRunning:'MultCloud ya está ejecutando un proceso de análisis, vaya a "Descarga Offline" para verificarlo.'
    },
    taskListPopup: {
        deleteTask: 'Eliminar Tarea',
        pleaseSelect: 'Seleccione los datos antes de eliminarlos.',
        sureDeleteTask: '¿Está seguro de que desea eliminar la (s) tarea (s)?',
        deleteSingleTask: '¿Está seguro de que desea eliminar la tarea?',
        viewLogs: 'Ver los registros',
        selectCloud: 'Seleccione un cloud para guardar los archivos'
    },
    upgradeAccountPopup: {
        commonTitle: '5 tareas nube a nube en paralelo',
        commonDes: 'Por favor, actualiza a suscriptor y podrás ejecutar 5 tareas nube-a-nube en paralelo.',
        upgradeAccount: 'Actualizar Cuenta',
        upgradeHeadTitle:'5 URL o torrents paralelos',
        upgradeHeadContent:"Los usuarios gratuitos pueden tener 1 URL de transferencia o tarea de torrent a la vez. Actualice a suscriptor y tendrá 5 transferencias de URL o tareas de torrents que se transfieren a la vez.",
        currentPlan: 'Plan Actual',
        insufficientTraffic: 'Tráfico insuficiente cloud-to-cloud',
        insufficientTrafficDes: 'Ha consumido todo el tráfico de datos gratuito de este mes. Para obtener más tráfico, actualice a la versión premium.',
        filter: 'Transferir Archivos/Sincronizar Filtros',
        filterDes: 'Para activar transferir archivos/sincronizar filtros, Actualice a la versión premium.',
        modes: 'Modos de Sincronización Avanzados',
        offlineFree: '1 URL o torrent a la vez',
        offlinePremium: '5 URL o torrents paralelos',
        modesDes: 'Los suscriptores tienen Sincronización Bidireccional y 7 opciones personalizadas en Sincronización Unidireccional. Compatible con Sincronización de Backup Incremental.',
        // doubledSync: 'Sincronización Doble',
        // doubleSyncDes: 'Actualice a suscriptor y realice dos tareas de sincronización simultáneamente.',
        doubleRealTime:'Sincronización en tiempo real doble',
        doubleRealTimeSyncDes:'Actualizar a suscriptor y realizar dos tareas de sincronización en tiempo real simultáneamente.',
        doubledSync: 'Sincronización normal doble',
        doubleSyncDes: 'Actualizar a suscriptor y realizar dos tareas normales simultáneamente.',
        realTimeSyncing:'Sincronización En Tiempo Real Doble',
        norMalSyncing:'Sincronización Normal Doble',
        free: 'Gratis',
        premium: 'Premium',
        monthTraffic: '5GB Tráfico/Mes',
        syncMode: '2 Modos de Sincronización',
        scheduled: 'Transferencia/Sincronización/Copia de Seguridad Programada',
        scheduledDes: 'Para activar la función de programación, actualice a la versión superior.',
        moreTraffic: 'Más tráfico de datos según lo necesite',
        moreSyncModes: '8 Modos de Sincronización',
        transferSpeed: 'Velocidad de Transferencia Quintuplicada',
        doubleSync: 'Sincronización Doble',
        transferServer: 'VIP Servidor de Transferencia',
        customerSupport: 'VIP Atención al Cliente',
        syncSupported: 'Sincronización Bidireccional y 7 opciones personalizadas en Sincronización Unidireccional. Compatible con Sincronización Mirror.',
        greatlyIncreased: 'Hay 10 subprocesos para los suscriptores en lugar de dos, por lo que la velocidad de transferencia aumenta considerablemente.',
        sameTime: 'Los suscriptores pueden tener 2 tareas de sincronización en tiempo real y 2 tareas de sincronización normal (4 en total) ejecutándose simultáneamente.',
        normalSametime:'Los suscriptores pueden realizar dos tareas de sincronización normales al mismo tiempo.',
        automatically: 'Configure un filtro para transferir o sincronizar archivos con nombres de archivo definidos por el usuario o ciertas extensiones automáticamente.',
        multipleSync: 'Múltiples Objetivos de Sincronización',
        multipleSyncDes: 'Actualice a premium para activar la función de múltiples objetivos de sincronización.',
        freeDes:'Los usuarios gratuitos tienen  30GB tráfico de datos en total para transferir o sincronizar datos entre los servicios de almacenamiento en la nube cada mes.',
        task1: '1 tarea nube a nube a la vez',
        task5: '5 tareas nube a nube en paralelo',
        emailTitle: 'Conversiones de correo electrónico insuficientes',
        emailDes: 'Los usuarios gratuitos tienen 50 conversiones de Email cada mes, pero parece que necesitas más que eso. Actualiza a Premium y tendrás conversiones de Email ilimitadas.',
        emailsConversions: '50 conversiones de correo electrónico/mes',
        emailsUn: 'Conversiones de correo electrónico ilimitadas',
    },
    remindBindEmail:{
        bindExe:'Vincule su correo electrónico para ejecutar la tarea',
        onceBind:'Una vez que haya vinculado su correo electrónico, también puede obtener <span class="gift-flow">30GB</span> de tráfico de datos adicional de cloud a cloud adicional.',
        bindEmail:'Vincule su correo electrónico para activar las funciones principales de MultCloud.',
        coreFeatures:'Funciones Principales de Multclouds',
        tourAccount:'Cuenta Turística',
        connectCloud:'Conecte los Servicios en la Nube a MultCloud',
        viewCloud:'Ver Todos Los Archivos de Cloud a través de MultCloud',
        uploadFile:'Subir Archivos a Cloud a través de MultCloud',
        downloadCloud:'Descargar Archivos a Cloud a través de MultCloud',
        syncAndBackup:'Sincronizar y Hacer Backup de Archivos entre Clouds',
        transferFiles:'Transferir Archivos de Un Cloud a Otro',
        failed:'No se pudo ejecutar la operación. Vuelve a intentarlo más tarde.'
    },
    //todo 等待翻译
    salePagePopup:{
        sOffer:'Oferta especial por MENSUAL ILIMITADO',
        timeLimited:'¡Dale prisa, el tiempo es limitado!',
        Hours:'Horas',
        Minutes:'Minutos',
        Seconds:'Segundos',
        monthPrice:'$19.9/Mes',
        dataTra:'por tráfico de datos ILIMITADO',
        subscribe:'Suscríbase Ahora',
        features:'Funciones',
        freePlan:'Plan Gratuito',
        bigSale:'Gran venta por tiempo limitado',
        discountsto:'Descuentos hasta',
        off:'25% Off',
        premiumPlan:'Plan Premium',
        transmit:'Tráfico para transmitir',
        dataTraffic:'El tráfico de datos para la transferencia y sincronización de archivos de cloud a cloud.',
        originalPrice:'Precio Original',
        nowOnly:'Solo Ahora',
        getDiscount:'Obtener Descuento',
        moreData:'Más Tráfico de Datos',
        unlimitedData:'Tráfico de Datos Ilimitado',
        syncModes:'Modos de Sincronización',
        syncModesDes:'Los suscriptores tienen sincronización bidireccional y 7 opciones personalizadas en sincronización unidireccional. Compatible con Mirror Sync.',
        scheduledTran:'Transferencia Programada',
        scheduledTranDes:'Con esta función, puede programar una tarea automática de nube a nube a un intervalo regular o para un momento especial.',
        transferSpeedDes:'Hay 10 subprocesos para los suscriptores, en lugar de 2, por lo que la velocidad de transferencia aumenta considerablemente',
        fileEncryption:'Cifrado de Archivos',
        encryptFiles:'Los suscriptores pueden cifrar archivos en unidades en la nube en línea y subir archivos',
        quarterly:'Trimestral',
        yearly:'Anual',
        monthGb:'150GB/mensual',
        monthGbly:'200GB/mensual',
        monthfourLy:'400GB/mensual',
        unTr:'Tráfico ilimitado',
        nMonth:'/Mes',
        tQuarter:'/Cuarto',
        eYear:'/Año',
        tOneTime:'Una vez',
         //2021-10-09
        premiumFeatures:'¡150 GB de datos y todas las funciones avanzadas se pueden utilizar en un mes!',
        unlimitedYear:'¡El tráfico ilimitado y todas las funciones avanzadas se pueden utilizar en un año!',
        unlimitedLiftime:'¡El tráfico ilimitado y todas las funciones avanzadas se pueden utilizar de por vida!',
    },
    properties: 'Propiedades',
    general: 'General',
    tips: 'Consejos',
    progress: 'Progreso',
    limits: 'Límites de alnacemiento en la nube',
    detailed: 'Detallado',
    cancel: 'Cancelar Todo',
    simpleSync: 'Sincronización Simple',
    onewaySync: 'Sincronización Unidireccional',
    twowaySync: 'Sincronización Bidireccional',
    advancedSync: 'Modos de Sincronización Avanzados',
    mirrorSync: 'Sincronización Mirror',
    moveSync: 'Mover Sincronización',
    cmuSync: 'Sincronización Acumulativa',
    updateSync: 'Actualizar Sincronización',
    increSync: 'Sincronización Incremental',
    fullSync: 'Sincronización de Backup Completa',
    simpleSyncTip: 'Los archivos agregados, modificados y eliminados en el directorio de origen se replicarán en el directorio de destino. Sin embargo, los archivos agregados, modificados y eliminados en el directorio de destino no se replicarán en el directorio de origen.',
    mirrorSyncTip: 'Los archivos en los directorios de origen y destino son siempre los mismos (MultCloud eliminará los archivos adicionales en el directorio de destino).',
    moveSyncTip: 'Una vez que se complete la sincronización, se eliminarán todos los archivos del directorio de origen.',
    cmuSyncTip: 'Al eliminar los archivos en el directorio de origen, no se eliminarán los mismos archivos en el directorio de destino.',
    updateSyncTip: 'Todos los archivos en el directorio de destino se eliminarán en primer lugar, y luego los archivos agregados y modificados en el directorio de origen se transferirán al directorio de destino.',
    increSyncTip: 'Cada vez que sincronice archivos, se creará un subdirectorio en el directorio de destino para que los archivos agregados y modificados en el directorio de origen se transfieran a él.',
    fullSyncTip: 'Cada vez que sincronice archivos, se creará un subdirectorio en el directorio de destino para que todos los archivos del directorio de origen se transfieran a él.',
    twowaySyncTip: 'Los archivos agregados, modificados y eliminados en el directorio de origen se replicarán en el directorio de destino. Del mismo modo, los archivos agregados, modificados y eliminados en el directorio de destino se replicarán en el directorio de origen (es decir, los archivos en los directorios de origen y destino son siempre los mismos).',
    syncModes: 'Modos de Sincronización',
    email: 'Email',
    filter: 'Filtrar',
    thread: 'Thread',
    listThread: 'Número de hilos recorridos',
    runThread: 'Número de hilos ejecutados',
    sameName: 'Mismo nombre',
    filterInclude: 'Extensiones incluidas (p. ej., png, doc, mp4)',
    filterExclude: 'Nombres de archivos excluidos (p. ej., target, dist, build)',
    newFilterTag: 'Nueva etiqueta',
    createTaskStatus: 'Creado',
    pendingTaskStatus: 'Pendiente',
    runningTaskStatus: 'En ejecución',
    cancelledTaskStatus: 'Cancelado',
    completedTaskStatus: 'Éxito',
    failedTaskStatus: 'Fallido',
    warnTaskStatus: 'Advertencia',
    errorTaskStatus: 'Error',
    warning: 'Advertencia',
    logs: 'Registro',
    once: 'Solo una vez',
    daily: 'Diario',
    weekly: 'Semanal',
    monthly: 'Mensual',
    onlyOnce: 'Ejecutar solo una vez a:',
    everyDay: 'Ejecutar todos los días en:',
    everyWeek: 'Cada semana en:',
    at: 'A:',
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    runAt: 'Ejectuar a:',
    lastDay: 'Último Día',
    chooseAction: 'Si el archivo de destino ya existe. Elija una acción:',
    optionsPrompt: 'Si los archivos de la unidad de nube de origen tienen un carácter especial en el nombre de archivo que no está permitido en la unidad de nube de destino, los archivos se cambiarán de nombre automáticamente durante el proceso de transferencia y se creará un archivo log.html en el directorio raíz de la unidad de nube de destino.',
    sourceNewer: 'Sobrescribir si la recurso es más reciente.',
    diffSize: 'Sobrescribir si es diferente tamaño.',
    sourceAll: 'Sobrescribir si es diferente tamaño o fuente más reciente.',
    skipFile: 'Omitir el archivo.',
    skipEmail: 'Omite el correo electrónico.',
    overWrite: 'Sobrescribir siempre.',
    rename: 'Rebautizar',
    overWriteSourceNewer: 'Sobrescribir si hay una actualización del correo electrónico original. ',
    deleteAllSource: 'Eliminar todos los archivos de origen una vez completada la transferencia.',
    keepFileDate: `Mantener la fecha de modificación del archivo (Admite Dropbox, Google Drive, G Suite).`,
    automaRename: 'Rebautizar automáticamente los archivos que contienen caracteres especiales y genere un archivo de script',
    sendEmail: 'Envíar una notificación por correo electrónico cuando completa esta tarea.',
    sendMessage: 'Envíar un mensaje de prueba',
    ignoreFiles: 'Ignorar archivos con estas extensiones',
    includeFiles: 'Incluir solo archivos con estas extensiones',
    selectSync: 'Puede seleccionar el modo de sincronización aquí:',
    tipsFor: 'Consejos para',
    allTasks: 'Todas Tareas',
    successful: 'Exitosa',
    unfinished: 'Inconclusa',
    transferDetails: 'Detalles de Transferencia',
    redit: 'Re-editar',
    publicShare: 'Compartir Público',
    publicTip: 'Consejos: Cualquiera que obtenga el enlace puede ver el archivo',
    privateShare: 'Compartir Privado',
    privateTip: 'Consejos:Otros necesitan ingresar la contraseña para ver el archivo',
    sourceShare: 'Compartir Recurso',
    sourceTip: 'Consejos: Cree un enlace para compartir de la unidad de nube de origen',
    communityShare: 'Público en La Comunidad de MultCloud',
    communityTip: 'Notas: cualquiera puede buscar y ver el archivo en la comunidad de MultCloud',
    shareSuccess: 'Crear Compartir Exitoso',
    copySuccess: 'Copia Exitosa',
    sharedYet: "Este archivo ya se ha compartido",
    domain: 'Dominio',
    key: 'Key',
    secret: 'Secret',
    publicShareEasy: 'Cualquiera',
    privateShareEasy: 'Privado',
    communityShareEasy: 'Público',
    sourceShareEasy: 'Recurso',
     //2020-10-26-ljm增加
    progressBox:'Progreso',
    reportPopup: {
        title: 'Informe Compartir',
        beforeMsgOne: 'Ayúdanos a comprender qué está sucediendo con este recurso compartido.',
        beforeMsgTwo: '¿Cómo lo describiría?',
        typeItems: {
            spam: 'Correo no deseado',
            malwareVirus: 'Malware o virus',
            copyrightViolation: 'Violación de derechos de autor',
            illegal: 'Contenido ilegal',
            notWorking: 'MultCloud no funciona correctamente',
            other: 'Otro contenido inapropiado',
        },
        nextMsgOne: 'Complete la información sobre este informe.',
        description: 'Descripción',
        nextMsgTwo: 'Describe lo que está pasando con la acción.',
        yourEmail: 'Su Email',
        nextMsgThree: 'Proporcione su dirección de correo electrónico y nos comunicaremos con nosotros si es necesario.',
        submit: 'Entregue',
        back: 'Volver',
        next: 'Siguiente',
        messageNone: 'Introduzca la descripción de este informe.',
        emailNone: 'Ingrese su correo electrónico de contacto.',
        success: 'Su informe ya se envió al equipo de MultCloud.'
    },
    subAccountPopup:{
        title: "Gestión de subcuentas",
        titleMax: "Gestión de subcuentas",
        titleDes:"Actualice a suscriptor y podrá crear y administrar subcuentas.",
        tabNameUser: "Modo de Usuario",
        tabNameItem: "Modo de Carpeta",
        addItemButton: "Asignar Carpeta",
        users: "Usuarios",
        folders: "Carpetas",
        read: "Leer",
        write: "Escribir",
        questionTxtRead: "Los usuarios de subcuentas pueden descargar, obtener una vista previa y copiar archivos a sus clouds en esta carpeta.",
        questionTxtWrite: "Los usuarios de subcuentas pueden crear nuevas carpetas, subir, eliminar, renombrar archivos en esta carpeta.",
        userExist:"El usuario ya existe.",
        userSelf:"No puede agregarse a sí mismo como su subcuenta.",
        quickAssign: "Asignación rápida",
        quickAdd: "Adición rápida",
        allow: "Permitir",
        batchAddUserNull: "Actualmente no hay ningún usuario añadido.",
        batchAddItemNull: "Actualmente no hay ninguna carpeta añadida.",
        noUserFromAddItem: "Añada un usuario primero, por favor.",
        noItemFromAddUser: "Añada una carpeta primero, por favor.",
        addUser: {
            title: "Agregar Usuario",
            radioCreate: "Crear una subcuenta",
            radioAdd: "Agregar una cuenta existente de MultCloud",
            createNamePlaceholder: "Crear Nombre de Usuario",
            createPasswordPlaceholder: "Crear Contraseña",
            addNamePlaceholder: "Ingrese la cuenta existente de MultCloud",
            createNameNone: "Ingrese un nombre de usuario.",
            createNameMore: "El nombre de usuario debe tener menos de 20 caracteres.",
            createPasswordNone: "Introduzca una contraseña.",
            createPasswordError: "Introduzca una contraseña de 8 a 16 caracteres.",
            addUserNameNone: "Ingrese una cuenta existente de MultCloud.",
            addUserNone: "Esta cuenta no existe.",
        },
        addItem: {
            noFolder: "Seleccione una carpeta.",
            exist: "Ya ha agregado la carpeta.",
        },
        editUser: {
            title: "Editar subcuenta",
            namePlaceholder: "Introduzca un nombre de usuario",
        },
        cancel: {
            titleUser: "Eliminar subcuenta",
            titleItem: "Eliminar carpeta",
            msgUser: "¿Está seguro de eliminar esta cuenta?",
            msgItem: "¿Está seguro de eliminar esta carpeta?",
        },
        unknownError: "No puede encontrar la ruta, verifique si la ruta existe o vuelva a agregar la nube.",
    },
    verifyPopup:{
        verifyTitle: "Verifique su identidad",
        toRecoveryText: "No tengo ninguno de estos",
        verifyEmailTitle: "Verifique su correo electrónico",
        verifyEmailTips: "Enviaremos un código de verificación a {email}. Para verificar que esta es su dirección de correo electrónico, introdúzcala a continuación.",
        verifyPhoneTitle: "Verifique su número de teléfono",
        verifyPhoneTips: "Enviaremos un código de verificación a {phone}. Para verificar que es su número de teléfono, introduzca los 4 últimos dígitos incluidos {last}.",
        verifyPhoneText: "Los 4 últimos dígitos del número de teléfono móvil",
        sendCodeBtn: "Enviar código",
        enterCode: "Introducir código",
        checkEmailTips: "Si {email} coincide con el correo electrónico alternativo de su cuenta, le enviaremos un código.",
        checkPhoneTips: "Si {phone} coincide con los 4 últimos dígitos del número de teléfono de su cuenta, le enviaremos un código.",
        askDevice: "No me pregunte de nuevo en este dispositivo.",
        verify: "Verificar",
        recoveryTitile: "¿Tiene un código de recuperación de cuenta?",
        recoveryTipsOne: "Si tiene un código de recuperación, introdúzcalo ahora. Si no lo tiene, póngase en contacto con nosotros",
        recoveryTipsTwo: "Su código de recuperación tiene 25 caracteres y tiene el siguiente aspecto: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX.",
        recoveryCode: "Código de Recuperación",
        recoveryCodeBtn: "Utilizar el Código de Recuperación",
        recoveryChangeTitile: "¿Qué más podemos hacer para verificar su identidad?",
        recoveryEmailChange: "Añadir una dirección de correo electrónico alternativa",
        recoveryPhoneChange: "Añadir un número de teléfono",
        enterEmail: "Introduzca su correo electrónico",
        recoveryNextTitle: "Por favor, introduzca el código que enviamos a {checkCode}",
        recoveryTipsTitle: "Para su protección, ¡la sustitución de su información de seguridad tarda 30 días!",
        recoveryTips1: "Como ha activado la verificación en dos pasos, necesita información de seguridad actualizada para  iniciar sesión en su cuenta.",
        recoveryTips2: "Durante el periodo de espera no podrá acceder a sitios o servicios con su cuenta, pero sí a dispositivos.",
        recoveryTips3: "Puede evitar la espera con:",
        recoveryTips4: "Utilizando un dispositivo de confianza.",
        recoveryTips5: "Si tiene un dispositivo que no requiere códigos, úselo ahora y actualice su información de seguridad.",
        recoveryTips6: "Encontrando su información de seguridad.",
        recoveryTips7: "¿Hay alguna posibilidad de que no se haya perdido del todo? Si lo encuentra, úselo ahora para volver a activar su cuenta.",
        recoveryTips8: "La espera hace más difícil que otra persona se haga con su cuenta con una contraseña robada.",
        recoveryPendTitle: "Su cambio de información de seguridad aún está pendiente",
        recoveryPendTips1: "En {data} usted solicitó que su información de seguridad fuera reemplazada",
        recoveryPendTips2: "Información de seguridad actual",
        recoveryPendTips3: "Correo electrónico alternativo:",
        recoveryPendTips4: "Número de teléfono:",
        recoveryPendTips5: "Nueva información de seguridad",
        recoveryPendTips6: "Si quiere mantener su información de seguridad actual,",
        recoveryPendTips7: "cancelar esta solicitud.",
        recoveryCancelTitle: "Aquí tiene su nuevo código de recuperación",
        recoveryCancelTips1: "Para que su cuenta sea segura, necesita un nuevo código de recuperación.",
        recoveryCancelTips2: "Si alguna vez necesita recuperar el acceso a su cuenta, este código le ayudará. Debe anotarlo y guardarlo en un lugar seguro. Le recomendamos encarecidamente que no guarde su código de recuperación en un dispositivo.",
        recoveryCancelTips3: "Si anteriormente tenía un código de recuperación, ya no es válido. Utilice este nuevo código en su lugar.",
        recoveryCancelTips4: "Su nuevo código es:",
        recoveryCancelSucTitle: "¡Increíble! ¡Volvamos a su cuenta!",
        recoveryCancelSucTips1: "La actualización de la información de seguridad para {old} ha sido cancelada, y ahora tiene acceso completo a su cuenta.",
        recoveryCancelSucTips2: "La información de contacto utilizada para iniciar el proceso ({new}) se ha eliminado y no se utilizará como información de seguridad para su cuenta.",
        recoveryCancelSucTips3: "Click \"Next\" para volver a lo que estabas haciendo.",
        recoveryCancelErrorTitle: "Presentando la solicitud",
        recoveryCancelErrorTips: "Su cuenta sigue en periodo de espera.",
        codeText: "Introduzca Su Número de Teléfono",
        exception: {
            emailTwoStringError: "El correo electrónico correcto comienza con \"{errorCode}\".",
            validEmail: "Por favor, introduzca un correo electrónico correcto.",
            phoneLastTwoStringError: "El número correcto termina en {errorCode}.",
            validPhone: "Debe introducir los 4 últimos dígitos del número de teléfono.",
            verificationCodeExpired: "El código de verificación ha caducado.",
            verificationCodeError: "El código de verificación es incorrecto, por favor compruebe el código e inténtelo de nuevo.",
            verificationRecoveryCodeExpired: "El código no ha funcionado, por favor, compruebe el código e inténtelo de nuevo.",
            verificationCodeNull: "Introduzca el código de verificación por favor.",
        }
    },
    worldBackupPopup: {
        // title:'World Backup Day',
        title:'Oferta Especial de MultCloud',
        titleTip:'Venta Flash de 24 Horas',
        timerTitle:'La oferta por tiempo limitado terminará en',
        getOffer:'Obtener Oferta',
        tips100Mo:'Datos de tráfico 100GB/Mes',
        ps100Mo:'Nota: El tráfico de datos no utilizado se acumulará. Por ejemplo, sólo ha consumido 50 GB de 100 GB en el primer mes y todavía tendrá 50 GB adicionales de tráfico de datos en el mes siguiente.',
        tips1200Yr:'Datos de tráfico 1200GB/Año',
        ps1200Yr:'Nota: El tráfico de datos no utilizado se acumulará. Por ejemplo, sólo ha consumido 1.000 GB de 1.200 GB en el primer año y todavía tendrá 200 GB adicionales de tráfico de datos en el próximo año.',
        tips2400Yr:'Datos de tráfico 2400GB/Año',
        ps2400Yr:'Nota: El tráfico de datos no utilizado se acumulará. Por ejemplo, sólo ha consumido 2.000 GB de 2.400 GB en el primer año y todavía tendrá 400 GB adicionales de tráfico de datos en el próximo año.',
        tipsUnYr:'Datos de tráfico Ilimitado/Año',
        psUnYr:'Nota: ¡Tráfico de datos ilimitado durante un año!',
        tipsUnLi:'Datos de tráfico Ilimitados/de por Vida',
        psUnLi:'Nota: ¡Tráfico de datos ilimitado de por vida!',
        tips1:'10 hilos para transferir archivos',
        tips2:'Transferencia programada en la nube',
        tips3:'Asistencia prioritaria 24/7/365',
        ps1:'Hay 10 hilos para los abonados, mientras que 2 para los usuarios gratuitos, por lo que la velocidad de transferencia aumenta considerablemente.',
        ps2:'Los suscriptores pueden programar la transferencia/sincronización automática de nube a nube en un intervalo regular o para un momento especial.',
        moPrice:'{price} / Mes',
    },
    iosPayTipPopup: {
        title: 'Cancelar suscripción de Apple',
        tip: 'Su actual {name} está en estado de renovación automática (ID de transacción de Apple: {id}), por favor, cancele la suscripción y vuelva a intentarlo.',
        btnTxt: 'Cómo cancelar',
    },
    appRecommendPopup: {
        title: '¡La nueva aplicación móvil de MultCloud ya está disponible!',
        tip: 'Descárgalo inmediatamente para gestionar y transferir <br>datos entre nubes con dispositivos móviles.',
        modileTitle: '¡Obtenga la aplicación móvil de MultCloud ahora!',
        iosBtnTitle: 'Consíguelo en el',
        iosBtnTip: 'App Store',
        androidBtnTitle: 'DISPONIBLE EN',
        androidBtnTip: 'Google Play',
        apkBtnTitle: 'Descargar',
        apkBtnTip: 'MultCloud',
    },
    note: 'Nota',
    editCloudNoticPopup: {
        tips: 'La autorización ha caducado, por favor, vuelve a añadir la nube a MultCloud e inténtalo de nuevo.',
        btnTxt: 'Re-añadir',
    },
    appleTipsPopup: {
        title: 'Consejos',
        tipTitle: 'Consejos para la autenticación de 2 factores de Fotos de iCloud',
        tip1: 'Para conectar tus Fotos de iCloud a MultCloud, necesitas conceder acceso al servidor de MultCloud a tu ID de Apple. Así que usted puede ver nuestra ubicación del servidor difiere de su ubicación real durante el procedimiento de autenticación de 2 factores.',
        tip2: 'Y por favor recuerde: Su seguridad y privacidad es nuestra prioridad. MultCloud no almacena sus datos de forma permanente. Puede almacenar temporalmente en caché parte del contenido basado en sus operaciones, sin embargo, se eliminará de nuestro servidor inmediatamente una vez que la operación se realiza. Y la conexión entre tus Fotos de iCloud y los servidores de MultCloud se realiza siempre a través de un canal seguro SSL de 256 bits.',
        checkTip: 'No vuelvas a mostrar esto',
    },
    iCloudDriveTips: {
        title: 'Consejos',
        tipTitle: 'Consejos para la autenticación de 2 factores de iCloud Drive',
        tip1: 'Para conectar tu iCloud Drive a MultCloud, necesitas conceder acceso al servidor de MultCloud a tu ID de Apple. Así que usted puede ver nuestra ubicación del servidor difiere de su ubicación real durante el procedimiento de autenticación de 2 factores.',
        tip2: 'Y recuerda: tu seguridad y privacidad son nuestra prioridad número 1. MultCloud no almacena tus datos de forma permanente. Podría almacenar temporalmente en caché parte del contenido en función de tus operaciones, sin embargo, se eliminará de nuestro servidor inmediatamente una vez finalizada la operación. Además, la conexión entre tu iCloud Drive y los servidores de MultCloud se realiza siempre a través de un canal seguro SSL de 256 bits.',
        checkTip: 'No vuelvas a mostrar esto', 
    },
    checkApplePopup: {
        title: 'Autenticación de doble factor',
        tip1: 'Ha activado la autenticación de doble factor. Introduce el código de verificación en tu iPhone/iPad/iPod para continuar.',
        tip2: '¿No ha recibido un código de verificación?',
        btn1: 'Enviando mensaje...',
        btn2: 'Reenviar Código',
        btn3: 'Escríbeme',
        btn4: 'Obtener Ayuda',
        suc1: 'Se ha enviado un mensaje con un código de verificación a {num}.',
        suc2: 'Se ha enviado un mensaje con un código de verificación a sus dispositivos.',
        fail1: 'No se ha podido enviar el código de verificación, inténtelo de nuevo.',
        fail2: 'Introduzca el código de verificación para continuar.',
    },
    downloadThreadPopup: {
        title: "Descargar Ajustes",
        tips: "Nombre del archivo descargado",
        defaultNameOne: "Emails saved on {date}",
        defaultName: "{num} emails saved on {date}",
        option1: "Guardar archivos adjuntos",
        option2: "Formato de conversación",
        option2Tips: "Los presupuestos se eliminarán cuando se activen.",
        option3: "Guardar sólo el último mensaje",
    },
    failedFilesPopup: {
        title: 'Ver archivos fallidos: {num}',
        exportExcel: 'Exportar como Excel',
        retrySucTip: '{num} elementos añadidos a la lista de reintentos.',
    },
    viewLogsPopup: {
        title: 'Detalles de la tarea:',
        titleRe: 'Detalles de la restauración:',
        errorNum: 'Número de fallos',
        addNum: 'Archivos añadidos',
        updateNum: 'Archivos actualizados',
        deleteNum: 'Archivos eliminados',
        syncSize: 'Tamaño de sincronización',
        syncTime: 'Tiempo de sincronización',
        backupNum: 'Cantidad de copias de seguridad',
        backupSize: 'Tamaño de copia de seguridad',
        backupTime: 'Tiempo de copia de seguridad',
        restoreNum: 'Número de restauraciones',
        restoreSize: 'Tamaño de restauración',
        restoreTime: 'Tiempo de restauración',
        tranNum: 'Cantidad de transferencias',
        tranSize: 'Tamaño de transferencia',
        tranTime: 'Tiempo de transferencia',
        from: 'Origen:',
        to: 'Destino:',
        executeTime: 'Hora de ejecución:',
        sourceAccount: 'Cuenta de origen',
        targetAccounts: 'Cuentas de destino',
        executeResult: 'Resultado de ejecución',
        add: 'Añadido:',
        update: 'Actualizado:',
        delete: 'Eliminado:',
    },
    taskProgressPopup: {
        title1: 'Eres el usuario premium, ahora puedes transferir archivos simultáneamente con 10 hilos.',
        title2: 'Actualiza a cualquier servicio premium para disfrutar de hasta 10 hilos.',
        btnTip: 'Desde solo 9.99 €',
    },
    subfileSelectPopup: {
        title: 'Selecciona contenido para subir',
    },
    deleteBatchPopup: {
        tips1: '¿Está seguro de que desea eliminar estas <span>{num}</span> tareas?',
        tips2: 'Una vez eliminadas, las tareas no se podrán recuperar',
    },
    freeSaledPopup: {
        tips1: 'Haz copias de seguridad de forma más inteligente en el Día Mundial del Backup Obtén 50 GB GRATIS de transferencia entre nubes por tiempo limitado',
        tips2: '¡Espera!',
        tips3: 'Parece que estás a punto de perder tu regalo del Día Mundial del Backup. Recuerda: si lo dejas pasar, ¡no volverá!',
        btns1: 'Reclamar 50 GB',
        btns2: 'No, gracias',
        success: '¡Felicidades! Acaba de recibir 50 GB de tráfico de transferencia.',
        floatTitle: '¡OBTÉN 50GB GRATIS!',
        popupTitle: '¡OBTÉN <span>50GB</span> GRATIS!',
    }
},
addCloud: {
    connectDesc: 'Haga clic en el almacenamiento en la nube para conectarla a MultCloud',
    box: 'Box',
    boxBusiness:'box for Business',
    dropbox: 'Dropbox',
    google_drive: 'Google Drive',
     google_drive_sharedWithMe: 'Shared with me',
    google_drive_v2: 'Google Drive',
    google_drive_shared_v2: 'Shared with me',
    oneDrive: 'OneDrive',
    oneDriveV2: 'OneDrive',
    sugarSync: 'SugarSync',
    amazonS3: 'Amazon S3',
    iDrivee2: 'IDrive® e2',
    wasabi:'Wasabi',
    webDav: 'WebDAV',
    FTP: 'FTP',
    cloudMe: 'CloudMe',
    cubby: 'Cubby',
    myDrive: 'MyDrive',
    yandex: 'Yandex',
    hiDrive: 'HiDrive',
    WEBDE: 'WEB.DE',
    baiDu: 'BaiDu',
    amazon: 'Amazon',
    alfresco: 'Alfresco',
    aDrive: 'ADrive',
    Icedrive: 'Icedrive',
    NAS: 'NAS',
    oneDrive4Business: 'OneDrive for Business',
    dropbox4Business: 'Dropbox for Business',
    pCloud: 'pCloud',
    mega: 'MEGA',
    backblaze: 'Backblaze',
    putio: 'Putio',
    googlePhotos: 'Google Photos',
    googlePhotosV2: 'Google Photos',
    gSuiteSharedDrive: 'Shared Drive',
    evernote: 'Evernote',
    flickr: 'Flickr',
    mediafire: 'MediaFire',
    ownCloud: 'ownCloud',
    mySQL: 'MySQL',
    gSuite: 'Google Workspace',
    hubiC: 'hubiC',
    egnyte: 'Egnyte',
    youtube: 'youtube',
    facebook: 'facebook',
    picasa: 'picasa',
    goDaddy: 'goDaddy',
    ubuntu: 'ubuntu',
    welcomeTo: 'Bienvenido a MultCloud',
    peCloud:'Clouds Personales',
    buCloud:'Clouds Empresariales',
    welcomeFont: 'Ahora puede transferir y administrar fácilmente todos sus archivos en cloud con una sola aplicación. Primero, conecte su cloud a MultCloud.',
    sharePointOnline:"SharePoint Online",
    iCloudPhotos: 'iCloud Fotos',
    gmail: 'Gmail',
    comingSoon: 'Muy pronto...',
    iCloudDrive: 'iCloud Drive',
    signInWith: 'Iniciar sesión con',
    outlook: 'Outlook',
    fourShared: '4shared',
},
addEmail: {
    connectDesc: 'Haz clic en el correo electrónico para conectarlo a MultCloud',
    peEmail: 'Seleccione e inicie sesión con el correo electrónico',
    iCloudNotice: 'iCloud Drive no se puede conectar temporalmente y nuestro equipo de desarrollo está trabajando para resolver el problema.',
    iCloudPhotosNotice: 'Fotos en iCloud no se puede conectar temporalmente y nuestro equipo de desarrollo está trabajando para resolver el problema.',
},
cloudExploer: {
    uploadFile: 'Subir Archivo',
    newFolder: 'Nueva Carpeta',
    newAlbum: 'Nuevo álbum',
    search: 'Buscar',
    grid: 'Cuadrícula',
    pageList: 'Lista',
    reFresh: 'Actualizar',
    modified: 'Modificado en',
    openWith: 'Abrir con',
    officeOnline: 'Microsoft Office Online',
    loading: 'Espere, cargando…',
    uploadFolder: 'Subir Carpeta',
    trash: 'Papelera de reciclaje',
    recentlyDeleted: 'Eliminado recientemente',
    jumpTo: 'Salta a',
    deleteForever: 'Borrar para siempre',
    restore: 'Restaurar',
    back: 'Volver',
    searchResult: 'Resultado de búsqueda',
    emptyTrash: 'Vaciar Papelera de reciclaje',
    recoverAll: 'Recuperar todo',
    deleteAll: 'Eliminar todo',
    fileExists: 'Archivo Existe',
    chooseOption: 'El archivo existe, elija una opción.',
    needRestore: 'Para ver esta carpeta, deberá restaurarla de su papelera de reciclaje',
    limitBoxTip: '1.Algunos almacenamientos en la nube pueden tener algunas limitaciones. Por ejemplo, Box no admite la transmisión de un solo archivo de más de 2GB. Estas limitaciones las establece el proveedor de cloud y MultCloud no las puede romper. Para obtener más información,<a href="https://www.multcloud.com/help/limitations.html" target="_blank" class="add-cloud-link">haga clic aquí</a>.<br>2. Si sus tareas aún no obtuvieron 10 subprocesos después de actualizar a premium, cancele y vuelva a transferir las tareas. Sus tareas obtendrán 10 hilos para transferir con servidores exclusivos vip.',
    fileNameNotEmpty: 'El nombre de archivo que ingresó no puede estar vacío.',
    notContainSpecialChar: 'El nombre del archivo no puede contener caracteres especiales `/ \ | : * ? " < >`.',
    CharacterLimit:'El nombre del archivo no puede contener caracteres especiales `~"# %& *: < >？ / \ { | }.`',
    pathNotExist: 'La ruta no existe',
    emptyNotice: 'Esta carpeta está vacía',
    trashEmpty: 'La papelera de reciclaje está vacía',
    searchEmpty: 'Los resultados de la búsqueda están vacíos',
    uploadSize: 'El tamaño total de una tarea de carga no puede ser superior a 1GB.',
    simultaneous: 'Puede agregar como máximo 200 tareas simultáneamente.',
    cancelFailed: 'La cancelación falló, la tarea se está creando. Vuelve a intentarlo más tarde.',
    notWith: 'Los nombres de archivo y carpeta no pueden comenzar ni terminar con "."',
    notUpload: 'subida fallida.',
    duplicatePhoto: 'Duplicar foto. La foto que has intentado cargar ya estaba en la fototeca y no se ha importado.',
    dataLoaded: 'Datos cargados',
    sharedDate:' Fecha de compartir',
    failedRestore: 'No se pudo restaurar el archivo porque el directorio de destino contiene un archivo con el mismo nombre de archivo.',
    //2020-12-11 lijimin
    uploadError:'Este archivo está prohibido descargar (desde el servicio oficial en la nube).',
    downloadLimit: 'Se ha alcanzado el límite de descargas para hoy. Por favor, inténtelo de nuevo mañana.',
    //2022-4-26 wt
    newBucket:'Nuevo Cubo',
    createBucket:'El nombre del cubo sólo debe contener letras minúsculas y números. La longitud debe ser de 3 a 63 caracteres. p.d. El nombre del cubo no debe ser todo números ( ej. "12345678")"',
    deleteBucket:'MultCloud no puede eliminar cubos con una convención de nombres de todos los números( ej. "12345678").',
    getBucketObjectListFail :'MultCloud no puede listar un cubo con una convención de nombres de todos los números( ej. "12345678").',
    newAlubm: '',
    specialCharError: 'El nombre del archivo no puede contener caracteres especiales `/ | : * ? " < >`.',
},
emailExploer: {
    from: 'Remitente',
    to: 'Destinatario',
    cc: 'Cc',
    email: 'Correos electrónicos',
    subject: 'Tema',
    received: 'Recibido',
    sentTime: 'Enviado',
    downloadMax200: 'Como máximo, puede descargar 200 correos electrónicos a la vez.',
    noSubject: '(sin asunto)',
    folderName: {
        Inbox: 'Recibidos',
        Starred: 'Destacados',
        Snoozed: 'Pospuestos',
        Sent: 'Enviados',
        Drafts: 'Borradores',
        Important: 'Importantes',
        Chats: 'Chats',
        Scheduled: 'Programados',
        AllMail: 'Todos',
        Spam: 'Spam',
        Trash: 'Papelera',
        Unread: 'No leidos',
        Categories_Social: 'Categorias_Social',
        Categories_Updates: 'Categorias_Notificaciones',
        Categories_Forums: 'Categorias_Foros',
        Categories_Promotions: 'Categorias_Promociones',
        Categories_Personal: 'Categorias_Personal',
    }
},
imageSaver: {
    analyzing: 'Analizando',
    failedToParse: 'Error al analizar',
    noviceGuidance: 'Aquí puedes revisar todas las imágenes/videos recientemente cargados a la nube o imágenes/videos empaquetados para Instagram.',
    insDownloadExist: 'Ya ha descargado este perfil. Puede encontrarlo en la sección «Lista de tareas».',
    taskExpiredOn: 'Caducado el {time}',
    taskStoringTill: 'Guardar hasta {time}',
    taskPart: 'Parte',
    taskUnitFile: 'archivo',
    taskUnitFiles: 'archivos',
    taskQueue: 'En espera',
    taskTabUpload: 'Cargar',
    taskTabSaveAll: 'Guardar todo en la nube',
    taskTabDownload: 'IG Descargar todo',
    downloadInsVideo: 'Descargar el vídeo',
    downloadSinglePost: 'Descargar la publicación completa',
    downloadAllPosts: 'Descargar todas las publicaciones',
    downloadAllReels: 'Descargar todos los Reels',
    downloadAllStories: 'Descargar todas las historias',
    downloadAllHighlights: 'Descargar todos los aspectos destacados',
    saveInsVideo: 'Guardar el vídeo en la nube',
    saveSinglePost: 'Guardar publicación completa en la nube',
    saveAllPosts: 'Guardar todas las publicaciones en la nube',
    saveAllReels: 'Guardar todos los Reels en la nube',
    saveAllStories: 'Guardar todas las historias en la nube',
    saveAllHighlights: 'Guardar todos los destacados en la nube',
    insCardPosts: 'publicaciones',
    insCardFollowers: 'seguidores',
    insCardFollowing: 'seguidos',
    insTabPosts: 'Fotos y Vídeos',
    insTabReels: 'Reels',
    insTabStories: 'Historias',
    insTabHighlights: 'Destacado',
    insBlankText: 'Con Descargador de Instagram de MultCloud, descargue y guarde sin esfuerzo publicaciones, reels, historias y momentos destacados de Instagram para administrar su contenido favorito en cualquier momento.',
    webGoogleBlankText: 'Recopila sin esfuerzo imágenes de cualquier sitio web o búsqueda en Google y guárdalas directamente en tu nube o almacenamiento local.',
    noTask: 'Sin tareas',
    inputTipHttp: 'Introduzca la URL de un sitio web o una palabra clave de búsqueda en Google',
    fetchBtn: 'Obtener',
    fetchingBtn: 'Buscando...',
    loadMore: 'Cargar más',
    downloadAll: 'Descargar todo',
    saveAll: 'Guardar todo en la nube',
    saveToCloud: 'Guardar en la nube',
    clearHistory: 'Borrar historial',
    cancel: 'Cancelar',
    retry: 'Reintentar',
    view: 'Ver',
    noImage: 'No se ha encontrado contenido',
    notSupport: 'Puede que esta URL no sea compatible. Compruebe la URL e inténtelo de nuevo.',
    inputTipIns: 'Ingresa una URL de Instagram',
    post: 'post',
    posts: 'posts',
    uploadTo: 'Subir a: ',
    download: 'Descargar',
    uploading: 'Cargando',
    finished: 'Finalizado',
    all: 'Todos',
    videoInputTip: 'Pegue aquí el enlace de su vídeo',
    videoTip: `Descarga vídeos de alta calidad de YouTube, Facebook, X y más de <a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1000 sitios</a> 
    con el descargador de vídeo en línea multiplataforma y sin anuncios de MultCloud — sin necesidad de instalación.`,
    process: 'Procesando...',
    thumbnail: 'Miniatura',
    abrTypeVeryHigh: 'Muy Alta',
    abrTypeHigh: 'Alta',
    abrTypeNormal: 'Normal',
    abrTypeLow: 'Baja',
    default: 'Por defecto',
    generat: 'Generando archivo',
    retryTip: 'La tarea se ha reiniciado. Puedes ver el progreso más reciente en la pestaña "Todos".',
},
taskList: {
    taskListDes: 'Puede administrar la transferencia en la nube, la sincronización en la nube y las tareas de almacenamiento de archivos compartidos aquí',
    multiCloudSync: 'Multi-Clouds Sincronizar',
    MultiCloudTransfer: 'Multi-Clouds Transferir',
    nextTransfer: 'Siguiente Transferencia',
    scheduled: 'Programado',
    nextSync: 'Siguiente Sincronización',
    reTransfer: 'Re-transferir',
    saveNow: 'Guardar Ahora',
    transferTasks: 'Tareas de Transferencia',
    syncTasks: 'Tareas de Sincronización',
    shareTasks: 'Tareas de Compartimiento',
    backupTasks: 'Tareas de copia de seguridad',
    emailTransferTasks: 'Email Migration Tasks',
    allTime: 'Todo el Tiempo',
    today: 'Hoy',
    latestWeek: 'Última Semana',
    latestMonth: 'Último Mes',
    customDate: 'Fecha Personalizada',
    allStatus: 'Todo Estado',
    preset: 'Preestablecer',
    noTaskCreated: 'No se ha creado ninguna tarea',
    createTransferTask: 'Crear una tarea de transferencia',
    createSyncTask: 'Crear una tarea de sincronización',
    createRemoteTask: 'Crear una tarea remota',
    timeMustLess: 'La hora de inicio debe ser menor o igual que la hora de finalización',
    taskNameRule: 'El nombre de la tarea no puede superar los 255 caracteres',
    backupTaskNameRule:'El nombre de la tarea no puede superar los 255 caracteres',
    detailNote: 'Esta tarea aún se está preparando, no se muestra ningún progreso detallado.',
    notTraffic: 'No hay suficiente tráfico de datos para la transmisión de nube a nube',
    reSync:'Sincronizar de nuevo',
    rebackup:'Copiar de seguridad de nuevo',
    rerestore:'Restaurar de nuevo',
    //2021-10-11
    createBackupTask:'Crear una tarea de copia de seguridad',
    createTeamTransferTask:'Crear una tarea de transferencia de equipo',
    multiClouds: 'Multinube',
    speedUP: 'Acelerar',
    noTasks: 'Sin tareas',
    noTasksTip: 'Inicia tu primera tarea y disfruta de una transferencia y sincronización entre nubes sin interrupciones.',
    loadingTip: 'Espera un momento, por favor.',
    allTasks: 'Todas las tareas ({num})',
},
cloudTransfer: {
    transferDescription: 'Configure una tarea de transferencia para transferir archivos entre unidades en la nube',
    transferOperateFrom: 'Haga clic aquí para seleccionar las unidades o carpetas en la nube desde las que desea transferir',
    from: 'DESDE',
    to: 'A',
    transferOperateTo: 'Haga clic aquí para seleccionar la unidad en la nube o la carpeta a la que le gustaría transferir',
    transferNow: 'Transferir Ahora',
    transfer: 'Transferir',
    addTaskOnly: 'Agregar Tarea Solamente',
    addTaskNow: 'Agregar Tarea y Transferir Ahora',
    addSyncTaskNow: 'Agregar Tarea y Sincronizar Ahora',
    addBackupTaskNow:'Agregar tarea y copia de seguridad ahora',
    transferSucces: 'Transferir Exitosamente',
    sureContinue: 'Ha seleccionado más de 10 elementos de origen y cada elemento de origen corresponde a un Email de notificación. Eso significa que puede recibir más de 10 correos electrónicos de notificación. ¿Está seguro de continuar?',
    sure: 'Sí, estoy seguro.',
     //2020-10-29ljm新增
     sourceRemind:'El número máximo de elementos de origen es 200. Seleccione menos elementos o seleccione una carpeta completa. PD Una carpeta completa solo cuenta con un elemento.',
     backupSourceRemind:'El número máximo de elementos de origen es 1000. Seleccione menos elementos o seleccione una carpeta completa. PD Una carpeta completa solo cuenta con un elemento.'
},
cloudSync: {
    syncDescription: 'Configure una tarea de sincronización para sincronizar archivos entre unidades en la nube',
    syncOperateTo: 'Haga clic aquí para seleccionar las unidades o carpetas en la nube con las que desea sincronizar',
    syncOperateFrom: 'Haga clic aquí para seleccionar la unidad o carpeta en la nube desde la que desea sincronizar',
    syncNow: 'Sincronizar Ahora',
    aimRemind:'El número máximo de directorios de destino es 200.',
    taskEmpty: 'El nombre de la tarea no puede estar vacío.',
    realTimeSync:'Sincronización en tiempo real',
    normalSync:'Sincronización normal',
    pause:'Pausa',
    paused:'Pausado',
    swicthTwoWay:'Cambiar a sincronización bidireccional',
    switchOneWay:'Cambiar a sincronización unidireccional',
    fristSync:'Primera Sincronización',
    lastSync:'Última sincronización',
    initSync:'La sincronización inicial de datos aún está en curso, espere.',
    realSyncing:'Sincronización en tiempo real...',
    servicesSu:'Servicios en la nube compatibles con la sincronización en tiempo real',
    addRealDrives:'Debe agregar una unidad en la nube que admita la sincronización en tiempo real.',
    egDrives:'Por ahora, solo Google Drive, Dropbox, Dropbox Business, OneDrive, OneDrive for Business, G Suite, box son compatibles con la sincronización en tiempo real.',
    initTial:'Inicializando',
    realSync:'Sincronización en tiempo real',
    createdAt:'Creado en',
    oneWaySimple:'Unidireccional (Sincronización Simple)',
    twoWay:'Bidireccional (Próximamente...)',
    gooleFolder:'No se sincronizará si solo hay cambios en los subdirectorios de una carpeta de Google Drive.',
    realTimeNotice:'Puede tener hasta 2 tareas de sincronización en tiempo real ejecutándose al mismo tiempo, por lo que algunas de sus subtareas se detendrán. ¿Está seguro de continuar?',
    reachMax:'Ha alcanzado el número máximo de registros, solo se muestran los registros más recientes.',
    notRun:'la tarea no se está ejecutando.',
    bePaused:'Si la tarea de sincronización en tiempo real permanece inactiva durante más de 7 días, la tarea se suspenderá automáticamente.',
    dontShow:'No vuelva a mostrar esto.',
    timeOut:'El tiempo de espera de travesía.',
    outMostly:'El tiempo de espera de travesía se debe principalmente a que hay demasiados archivos o subdirectorios que deben sincronizarse en tiempo real. En su lugar, recomendamos crear una tarea de sincronización normal.'
},
emailTransfer: {
    cloudEmail: 'Migración de Email',
    description: 'Migra tu correo electrónico a la nube como PDF.',
    migrationSetting: 'Configuración de migración',
    cutSetting: 'Cortar-Configuración',
    copySetting: 'Copiar-Configuración',
    settingTips: '',
    notification: 'Notificación',
    watermark: 'Marca de agua',
    delWatermark: 'Quite las marcas de agua de los correos descargados como PDF',
    saveAtt: 'Guardar archivos adjuntos',
    converFormat: 'Formato de conversación',
    converFormatTip: 'Los presupuestos se eliminarán cuando se activen.',
    saveOnly: 'Guardar sólo el último mensaje',
    optionTitle: 'Ya existen algunos correos electrónicos, ¿qué le gustaría hacer?',
    filterTitle: 'Puede especificar un filtro adicional para la selección DESDE.',
    filterMessage: 'Introduzca las direcciones de correo electrónico y sepárelas con comas',
    filterOption1: 'Sobrescribirla si se ha actualizado la conversación',
    filterOption2: 'Saltar siempre',
    filterOption3: 'Cambiar siempre el nombre',
    filterOption4: 'Contiene archivos adjuntos',
    filterOption5: 'No leidos',
    transferNow: 'Migrar Ahora',
    filterDateOptions1: 'Cualquier fecha',
    filterDateOptions2: 'Más de una semana',
    filterDateOptions3: 'Más de un mes',
    filterDateOptions4: 'Más de 6 meses',
    filterDateOptions5: 'Más de un año',
    filterDateOptions6: 'Intervalo personalizado...',
    showMore: 'Ver más',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de final',
},
exception: {
    exceedMaxLimit: 'El número de solicitudes superó el máximo.',
    cloudNameExist: 'Este nombre para mostrar ya existe, ingrese otro.',
    pathNotFound: 'Compruebe si existe un archivo o carpeta por la ruta dada.',
    notBeTheSame: 'La carpeta de origen y la carpeta de destino no pueden ser iguales.',
    notTransferring: 'Este directorio no se puede seleccionar para transferir archivos, seleccione sus subdirectorios u otros directorios.',
    verifyCodeInvalid: 'Error de código de verificación.',
    nameEmpty: 'El nombre para mostrar no puede estar vacío',
    emailEmpty: 'Email no puede estar vacío',
    serverEmpty: 'El servidor no puede estar vacío',
    usernameEmpty: 'El nombre de usuario no puede estar vacío',
    passwordEmpty: 'La contraseña no puede estar vacía',
    domainEmpty: 'Dominio no puede estar vacío',
    bucketNameEmpty: 'Bucket Name no puede estar vacío',
    accessKeyEmpty: 'Access Key ID no puede estar vacío',
    secretAccessKeyEmpty: 'Secret Access Key no puede estar vacía',
    keyIdEmpty: 'keyID no puede estar vacío',
    applicationKeyEmpty: 'ApplicationKey no puede estar vacía',
    onlyAlbum: 'Solo los directorios de álbumes creados o compartidos por MultCloud se pueden seleccionar para almacenar imágenes, videos y otros archivos multimedia.',
    parametersNotEmpty: 'Los parámetros no deben estar vacíos.',
    notMediaFiles: 'Nota: el directorio "Albums" solo puede almacenar directorios de álbumes, pero no archivos multimedia.',
    notStoreDirectories: 'El directorio "Photos" no puede almacenar directorios.',
    onlyStoreImages: 'Nota: el directorio "Photos" solo puede almacenar imágenes, videos y otros archivos multimedia, pero no directorios.',
    //400 云盘管理
    unknownError: 'Conexión fallida con este servicio. Por favor, reautorice el acceso de MultCloud al servicio.',
    addCloudFailed: 'Algunos parámetros no se ingresan correctamente.',
    renameCloudFailed: 'No se pudo cambiar el nombre de la nube. Vuelve a intentarlo más tarde.',
    deleteCloudFailed: 'No se pudo borrar el cloud. Vuelve a intentarlo más tarde.',
    invalidCloudAccount: 'Esta cuenta de cloud no existe.',
    //邮件管路
    bindEmailFail: 'No se pudo vincular el email.',
    linkHasExpired: 'El enlace caducó.',
    //文件管理
    listItemsFailed: 'No se pueden enumerar los archivos, vuelva a agregar la nube a MultCloud.',
    deleteItemFailed: 'No se pudo borrar el elemento.',
    renameItemFailed: 'No se pudo cambiar el nombre del elemento.',
    createFolderFailed: 'No se pudo crear la carpeta.',
    moveItemFailed: 'No se pudo mover el elemento.',
    shareItemFailed: 'No se pudo compartir el elemento.',
    uploadFailed: 'Datos de archivo no encontrados.',
    toFolderIdBlanked: 'El "tid" está en blanco',
    downloadFileFailed: 'No se pudo descargar el archivo, actualice la página o vuelva a agregar la nube a MultCloud.',
    //任务管理
    addTaskFail: 'No se pudo agregar la tarea.',
    taskQuotaLimit: 'Ha alcanzado el número máximo de 1000 tareas de transferencia de nube a nube, elimine algunas tareas sin importancia.',
    deleteTaskFail: 'No se pudo borrar la tarea.',
    maxRunningLimit: 'La tarea en ejecución supera el número máximo y esta tarea se puede agregar como en espera',
    userCreateFail: 'No se pudo crear el usuario. Vuelve a intentarlo más tarde.',
    userUpdateFail: 'No se pudo modificar la información de la cuenta, actualice la página e intente nuevamente.',
    createSaltFail: 'No se pudo crear sal. Vuelve a intentarlo.',
    listFolderFailed: 'No se pudo enumerar la carpeta, intente volver a agregar la nube.',
    //401
    cloudCategoryInvalid: 'El servicio de cloud ya es no compatible.',
    executeTaskFail: 'No se pudo ejecutar la tarea, verifique su conexión web.',
    parameterInvalid: 'Los parámetros no son válidos',
    saltInvalid: 'Su sesión ha expirado, inicie sesión nuevamente.',
    emailInvalid: 'No es un email valido.',
    notAuthorized: 'El nombre de usuario o la contraseña no son correctos.',
    //403
    cloudNameEmpty: 'El nombre para mostrar no puede estar vacío.',
    addCloudExpired: 'No se pudo agregar la nube, vuelva a agregar el servicio de cloud.',
    verifyCodeInvalid: 'El código de verificación no es válido.',
    emailExist: 'El correo electrónico ya existe.',
    exceedMaxLimit: 'Las solicitudes superaron el número máximo.',
    userIdNotNull: 'El ID de usuario es nulo',
    //404
    notFoundTask: 'La tarea no se encuentra.',
    noTaskRunning: 'No se está ejecutando ninguna tarea',
    userNotFound: 'El usuario no se encuentra.',
    loginerNotFound: 'El inicio de sesión no es compatible',
    deletePermissionLimited:'No puede proceder con esta operación, porque no tiene "Permiso de Borrado"',
    notHaveDeletePermission: 'No tienes permiso para borrar el archivo/carpeta.',
    uploadPermissionLimited:'No puede proceder con esta operación, porque no tiene "Permiso de carga"',
    movePermissionLimited:'No puede realizar esta operación porque no tiene "permiso de movimiento"',
    copyPermissionLimited:'No puede realizar esta operación porque no tiene "permiso de copia"',
    notHavePermission: 'Debido a la falta de permisos de escritura, no puede pegar este archivo/carpeta.',
    mkdirPermissionLimited:'No puede proceder con esta operación, porque no tiene "Permiso para crear una carpeta"',
    notCreatPermission: 'No puede crear un bucket o una carpeta debido a la falta de permisos de escritura o espacio insuficiente.',
    renamePermissionLimited:'No puede proceder con esta operación, porque no tiene "Permiso de renombrar"',
    creatIDriveFolderError: 'El nombre del objeto contiene caracteres no admitidos.',
    creatIDriveFolderToLong: 'El nombre de la carpeta no puede superar los 245 caracteres.',
    noUploadPermission: 'Debido a la falta de permisos de carga o al espacio insuficiente de almacenamiento en la nube, no puede cargar este archivo.',
    bucketNameLongError: 'Los nombres de los cubos deben tener entre 3 y 63 caracteres, utilizar sólo letras minúsculas, números, puntos (.) y guiones (-), empezar y terminar con una letra o un número y evitar los puntos seguidos.',
    bucketNameIsNotIp: 'El nombre del cubo no puede ser una dirección IP.',
    downloadPermissionLimited:'No puede proceder con esta operación, porque no tiene "Permiso de descarga"',
    ipNotFound: 'No se encuentra la ip',
    sugarSyncWarn: 'No es compatible para seleccionar el directorio, seleccione el directorio de "Web Archive","Magic Briefcase","Mobile Photos", sus subcarpetas u otros directorios.',
    flickWarn: 'No es compatible para seleccionar el directorio, seleccione el directorio de "/Albums", sus subcarpetas u otros directorios.',
    baiDuWarn: 'No es compatible para seleccionar el directorio, seleccione el directorio de "全部文件/我的应用数据/MultCloud", sus subcarpetas u otros directorios.',
    dropBoxbusinessWarn: 'No se admite seleccionar el directorio raíz, seleccione los otros directorios.',
    createFolderFail: 'No se pudo crear la carpeta',
    //mega报错
    addMegaFailed: 'Algunos parámetros no se han introducido correctamente o ha activado F2A.',
    //mySql报错
    mySqlWarn:'Esta nube no se puede seleccionar como destino de la transferencia de nube a nube.',
    //2020-12-4 xth
    shareNotUpload:'El propietario ha cancelado el permiso de \"Permitir subir\". Actualice la página.',
    //2020-12-9 xth
    shareItemUpdate:'El propietario ha cambiado el permiso para compartir enlace, actualice la página.',
    nameLong:'El nombre de usuario es demasiado largo (20 caracteres como máximo).',
    notPermission:'Este es un archivo de equipo y no tiene permiso para ejecutar esa operación.',
    notOpened:'Esta nube no admite la sincronización en tiempo real.',
    taskNotFound:'La tarea no existe.',
    subscribeFail:'No se pudo crear la tarea.',
    driveAccountIdInvalid:'No se puede crear la tarea de sincronización en tiempo real. Elimine y vuelva a agregar los servicios en la nube seleccionados y reintentarlo.',
    unknownState:'No se puede ejecutar esta operación, inténtelo de nuevo más tarde.',
    InvalidParameter:'Parametro Invalido.',
    InvalidDirectory:'El directorio raíz de box no admite esta función.',
    HasExist:'La tarea de sincronización instantánea para esta carpeta ya existe, cancele la tarea de sincronización instantánea para esta carpeta y vuelva a crearla en la carpeta',
    // taskRunningNumberLimited:'Puede ejecutar 5 tareas nube a nube en paralelo, por favor cancele una tarea en ejecución e inténtelo de nuevo.',
    taskRunningNumberLimited:'Ya hay 2 tareas de sincronización en tiempo real en estado de ejecución y, primero, pause una tarea de sincronización en tiempo real.',
    reachedLimit:'Ha alcanzado el límite de velocidad de este cloud, vuelve a intentarlo más tarde.',
    selectAlbumWarn:'Nota: Un directorio de álbumes solo puede almacenar imágenes, videos y otros archivos multimedia, pero no directorios.',
    notSupported:'La sincronización en tiempo real no es compatible con tareas con varios objetivos por ahora.',
    incorrectFormat:'Lo sentimos, el formato de su número de teléfono es incorrecto',
    taskMaximumNumberLimited:'Ha alcanzado el número máximo de 200 tareas de sincronización en tiempo real. Elimine algunas tareas de sincronización en tiempo real innecesarias y vuelva a intentarlo.',
    autoLoginFail:'Ha activado la verificación en dos pasos, por favor, inicie sesión de nuevo.',
    unsubscribeFail:'cancelar suscripción falla',
    //云盘操作报错
    alreadyAdd:'Ya has añadido la unidad de nube',
    toggleWhileEditing:'La cuenta que ha agregado no coincide con la cuenta actual.',
    //2022-4-25 wt
    emptyBucket:'No se pueden eliminar cubos que no estén vacíos. P.D. Por favor, asegúrese de que tampoco hay objetos en el cubo de versiones de Wasabi.',
    cannotCopyFolder:'No se puede copiar una carpeta en el mismo cubo.',
    cannotCopyIdrivee2Folder: 'Las carpetas de una misma cuenta Idrive e2 no pueden copiarse entre sí.',
    cannotCutFolder:'Las carpetas de un mismo cubo no pueden cortarse y pegarse entre sí.',
    bucketAlreadyExists:'El nombre del cubo solicitado no está disponible. El espacio de nombres del cubo es compartido por todos los usuarios del sistema. Por favor, seleccione un nombre diferente e inténtelo de nuevo.',
    accessPermissionLimited:'No tiene permiso para acceder a esta carpeta.',
    accessDenied:'Acceso denegado, no está autorizado a realizar esta operación.',
    shareTransferCanotCopy: 'Por ahora no se puede copiar la carpeta raíz de un recurso compartido de varios elementos.',
    // 2022-06-08 wt
    sharePointOnlineNotTrans:'El directorio raíz de SharePoint no puede ser seleccionado para transferir archivos, por favor seleccione un subdirectorio de un sitio.',
    sharePointListFailed:'Error 500: InternalServerError. Consejos: Por favor, compruebe si esta cuenta tiene acceso al servicio de SharePoint.',
    sameDirError: 'Las cuentas de origen y destino no deben ser las mismas.',
    
    accessDenied:'Acceso denegado',
    //iCloudPhotos报错
    onlySaveAlbums: 'Nota: El directorio de destino que seleccione sólo puede guardar álbumes (carpetas).',
    notSelectICloudPhotosRoot: 'Nota: El directorio raíz de Fotos de iCloud solo puede guardar álbumes (carpetas).',
    notSelectICloudPhotosForder: 'Nota: El directorio de destino que seleccione sólo puede guardar álbumes (carpetas).',
    notSelectICloudPhotosAlbum: 'Nota: El directorio de destino que seleccione sólo puede guardar imágenes (carpetas no disponibles).',
    notSelectICloudPhotosOther: 'Nota: El directorio de destino que seleccione no puede guardar imágenes directamente, todas las imágenes transferidas se guardarán en la carpeta "Recents".',
    notSelectICloudPhotosBackup: 'Fotos de iCloud no se puede seleccionar como destino de "Copia de seguridad en la nube". Para guardar imágenes en Fotos de iCloud, seleccione "Transferencia a la nube" o "Sincronización con la nube".',
    notSelectICloudPhotosSyncRoot: 'Nota: No se pueden sincronizar imágenes con el directorio raíz de Fotos de iCloud.',
    notSelectICloudPhotosSync: 'Se trata de una carpeta de Fotos de iCloud, solo puedes sincronizar imágenes con álbumes de Fotos de iCloud.',
    sendTooMany: 'Se han enviado demasiados códigos de verificación. Introduce el último código recibido, utiliza uno de tus dispositivos o inténtalo de nuevo más tarde.',
    verifySecurityCodeFailed: 'No se ha podido verificar, compruebe y vuelva a introducir el código de verificación.',
    appleNotEnablePhotos: 'Fotos en iCloud no está disponible para tu ID de Apple. Para utilizar Fotos en iCloud, inicia sesión con un ID de Apple que utilices con un dispositivo Apple.',
    tooManyRequests429: 'Límite de usuarios excedido. Reintentar después de {date}.',
    tooManyRequests403: 'Demasiadas solicitudes al mismo tiempo, por favor inténtelo más tarde.',
    // iCloudDrive报错
    folderNameIsTooLong: 'El nombre de la carpeta no puede superar los 255 caracteres.',
    fileNameIsTooLong: 'El nombre del archivo no puede superar los 250 caracteres.',
    iCloudDriveNotEnoughSpace: 'No hay espacio suficiente para cargar el archivo.',
    uploadFileIsTooBig: 'El archivo es demasiado grande para cargarlo. MultCloud actualmente limita las cargas a un máximo de 100 MB.',
    uploudFileSizeIsZero: 'No es posible cargar archivos de 0 bytes a iCloud Drive.',
    notUploudSpecialFile: 'No se puede cargar este tipo de archivo en esta biblioteca de apps.',
    notRenameApp: 'Apple no permite cambiar el nombre de las carpetas de aplicaciones, como Pages, Numbers y Keynote.',
    ErrorDeleteDistinguishedFolder: 'Las carpetas distinguidas no se pueden eliminar.',
    moreThan256Characters: 'El nombre de la carpeta no puede exceder los 256 caracteres.',
    cloudNotFound: 'La nube ha sido eliminada.',
    fourSharedUnauthorized:'Su autorización 4shared ha caducado. Vuelva a autorizar su cuenta haciendo clic en "Agregar de nuevo".',
    fileFolderNameLengthExceed:"La longitud del nombre del archivo/carpeta no puede exceder los 255 caracteres.",
    invalidLink: 'Enlace no válido.',
    requestFailed: 'Solicitud fallida.',
    exceeds2GB: 'El tamaño del archivo supera los 2 GB y no se puede descargar.',
    licenseUpgradError: 'La licencia no está disponible ya que usted es un suscriptor de {scheme}.',
    noLicenseCode: 'Introduzca un código de licencia',
    licenseCodeError: 'El código de licencia introducido es incorrecto.',
},
preview: {
    fileNotReview: 'los archivos no se pueden revisar',
    goOringinalSite:'Ir al Sitio Original'
},
remoteTask: {
    remoteTask: 'Tarea Remota',
    createTask: 'Crear Tarea',
    successsExceed: '¡Enlace copiado!',
    operateSuccess: 'Operar con éxito',
    noRemote: 'No se ha creado ninguna tarea remota',
    unKnownError: 'Un error desconocido',
    undefinedDisk:"No puede encontrar el directorio de destino, copie el enlace de descarga y cree una nueva tarea de carga remota.",
    taskExpired:'Ha caducado. Inténtalo de nuevo',
    createDescribe:'Transferir archivos desde enlaces, torrents, imanes directamente a sus nubes.',
    noSelectFile: 'Seleccione un archivo',
    excuteNow:'Ejecutar Ahora',
    noSeeds:'Poco Recurso',
	failedToParse:"Error al analizar.",
	parseMagnetRunning:'Analizar las semillas, espere...',
    selectedFileLimit:'El número total de archivos seleccionados no puede exceder 500 o el tamaño no excede 50G',
    addLink: 'Agregar enlace',
    startEmailSend: 'Enviar notificación por correo al finalizar la tarea',
    nowUpload: 'Subir ahora',
},
shares: {
    myShares: 'Mis compartimientos',
    savedShares: 'Compartimiento Guardadas',
    sharedOn: 'Compartido en',
    allowedTo: 'Permitir Subir',
    location: 'Ubicación',
    shareNull: 'Aún no ha compartido ningún archivo.',
    shareNullTips: 'Notas: Para compartir un archivo, haga clic derecho en el archivo y seleccione la opción "Compartir".',
    savedShareNull: 'Aún no ha guardado ningún archivo compartido.',
    savedShareNullTips: 'Notas: si alguien comparte un enlace para compartir con usted, puede guardarlo aquí para acceder rápidamente.',
},
login: {
    experienceSigning: 'Experiencia sin firmar',
    forgotPassword: '¿Contraseña Olvidada?',
    signIn: 'Registrarse',
    rememberMe: 'Recuérdame',
    keepLogin: 'Permanecer conectado',
    loginWith: 'Iniciar con',
    email: 'Email',
    password: 'Contraseña',
    verificationCode: 'Código de Verificación',
    firstName: 'Nombre',
    lastName: 'Apellido',
    confirmPassword: 'Confirmar Contraseña',
    createAccount: 'Crear Cuenta',
    continueWith: ' o continuar con',
    resetMessage: 'Enviar Mensaje de Reinicio',
    enterEmail: 'Ingrese la dirección de correo electrónico con la que se registró a continuación. Se enviará un correo electrónico con un enlace para restablecer su contraseña.',
    enterCorrectEmai: 'Ingrese el formato correcto de la dirección de correo electrónico.',
    passwordCharacters: 'La contraseña debe tener 8-16 caracteres',
    passwordDiff: 'Las dos contraseñas ingresadas son inconsistentes',
    enterCode: 'Ingrese el codigo de verificacion.',
    sentSuccess: 'El correo electrónico ha sido enviado con éxito.',
    successfully: 'Regístrese exitosamente',
    pleaseEmail: 'Introduzca su correo electrónico',
    pleasePassword: 'Introduzca su contraseña',
    accountActivated: 'Su cuenta no ha sido activada.',
    enterCorrectPass: 'Ingrese la dirección de correo electrónico correcta o el nombre y la contraseña de la cuenta temporal.',
    resetPasseord: 'Para proteger su cuenta, haga clic en “Olvidé Contraseña” para restablecerla.',
    validEmail: 'Introduzca una dirección de correo electrónico válida',
    enterFirstName: 'Ingrese su nombre.',
    enterLastName: 'Ingrese su apellido.',
    reEnterPass: 'Ingrese su contraseña otra vez.',
    creatingAccount: 'Al crear una cuenta, acepta las',
    termsUse: 'Términos de Uso',
    privacyPolicy: 'Política de Privacidad',
    thankYou: '¡Muchas Gracias!',
    checkEmail: 'Por favor revise su email',
    confirmRegistration: 'confirme su registro. Puede omitir el proceso de activación y utilizar nuestro producto normalmente, pero si olvida su contraseña, no podemos ayudarlo a recuperarla.',
    noteReceiveEmail: '¿No recibió correo electrónico?',
    receiveConfirmationEmail: 'Si no recibió un correo electrónico de confirmación, envíenos un correo electrónico a',
    buttonResend: 'o haz clic en el botón para reenviar.',
    forgetEmail: '¿Olvidaste tu dirección de correo electrónico?',
    sendEmailSupport: ' Envíe un correo electrónico al soporte',
    trackDown: 'Y lo rastrearemos.',
    passwordnotMatch: 'La contraseña que ingresaste no coincide',
    enterVaildPassWord: 'Por favor introduce una contraseña válida ',
    usernameNotContain: 'El nombre de usuario no puede contener caracteres especiales.',
    updatedSuccessfully: 'Sus datos se han actualizado correctamente',
    thankBindEmail: 'Gracias por la dirección de correo electrónico vinculante, verifique el correo electrónico de activación a tiempo',
    failExceedOperation: 'No realizar esta operación',
    enterNewPassword: 'Ingrese la nueva contraseña',
    confirmationPassword: 'Ingrese la contraseña de confirmación',
    userNameNot: 'el nombre de usuario no puede estar vacío',
     //login popup用
     signUp: 'Regístrate',
     logInButton: 'Iniciar sesión',
     logInWith: 'Iniciar con',
     logToMultCloud: 'Iniciar sesión a MultCloud',
     logEmailInput: 'Nombre de la cuenta de email/temporal',
     verificationIncorrect: 'La verificación que ingresaste es incorrecta.',
     signUpTitle: 'Regístrate y obtén 5GB de tráfico de datos gratis cada mes',
    title: "Transfiéralo a sus servicios en la nube con MultCloud.",
    tips: "¿Ya tiene una cuenta?",
    tips2: "¿No tiene una cuenta?",
    btnTxt: "iniciando sesión...",
    facebook: "Facebook",
    google: "Google",

    exception: {
        strEmpty: "Por favor rellene este campo.",
        nameToLong: "Su nombre de usuario debe tener 1-20 caracteres.",
        emailError: "Por favor, introduce una dirección de correo electrónico válida.",
        pwdError: "Introduzca una contraseña de 8-16 caracteres.",
        rePsdEmpty: "Por favor ingrese su contraseña otra vez.",
        rePwdError: "La contraseña no coincide.",
        codeEmpty: "Por favor ingrese el codigo de verificacion.",
        codeError: "El código de verificación debe tener 4 caracteres.",
        verifyCodeInvalid: "El código de verificación no es correcto.",
        emailExist: "La dirección de correo electrónico ya ha sido registrada.",
        emailPsdError: "El nombre de cuenta de correo electrónico/temporal o la contraseña no son correctos.",
    }
},
home: {
    driveNameNotContain: 'El nombre de la unidad no puede contener caracteres especiales `/ \ | : * ? " < >  &`.',
    cloudDiskName: 'El nombre del disco en la nube no puede superar los 200 caracteres.'

},
sharesPage: {
    linkFailure: 'Lo sentimos, este archivo compartido ha sido cancelado.',
    linkMasking: 'Lo sentimos, se ha bloqueado la visualización de este archivo compartido.',
    saveCloud: 'Guardar a Cloud',
    directDownload: 'Descargar Directamente',
    saveLink: 'Guardar el enlace',
    cancelShare:'Cancelar Compartir',
    uploadFile: 'Subir Archivo',
    newFolder: 'Nueva Carpeta',
    saveLinkSuccessBefore: 'Ha guardado correctamente el enlace.',
    saveLinkSuccessAfter: ' Ver Enlaces Guardados',
    saveLinkFail: 'No se ha podido guardar el enlace.',
    downloadingFolder: 'La carpeta de descarga no es compatible en este momento.',
    downloadingMore: 'Solo puede descargar un archivo a la vez.',
    downloadingNone: 'Por favor seleccione un archivo.',
    sharecanceledSuccess: 'Compartir cancelado.',
    sharecanceledFailed: 'No se pudo cancelar el compartimiento.',
    newFolderInRoot: 'Ingrese subdirectorios para crear una nueva carpeta.',
    uploadFileInRoot: 'Ingrese subdirectorios para cargar un archivo.',
    selectFileTransfer: 'Seleccione un archivo para transferir.',
    createTransferFailed: 'No se pudo crear la tarea de transferencia',
    createTransferSuccessBefore: 'Ha creado con éxito una tarea de transferencia.',
    createTransferSuccessAfter: ' Ver tarea',
    addCloudService: 'Agregar Servicio de Cloud',
    mustAddClouds: 'Debe agregar una unidad en la nube válida',
    selectSaveCloudTitle: 'Seleccione',
    moreClouds:'Más Clouds',
    saveLinkExists: 'El enlace ya existe.',
    errorShare404: 'Archivo fuente no encontrado.',
    passWordError: '¡Contraseña Incorrecta!',
    passWordNone: 'La contraseña no debe estar vacía.',
    passWordInputTitle: 'Archivo compartido privado MultCloud',
    passWordInputMsg: 'Introduzca la contraseña.',
    passWordInputButton: 'OK',
    loginErrorMax: 'No ha actualizado su contraseña durante bastante tiempo, actualice su contraseña.',
    uploadFolder: 'Solo puede subir archivos por el momento.',
    pleaseSignIn: 'Inicie sesión en MultCloud, por favor.',
},
share:{
    noManageMyShare: "Puede administrar todos sus archivos compartidos aquí.",
    noManageSavedShare: "Puede administrar todos los recursos compartidos guardados aquí.",
    unknownError: "El archivo compartido se pierde, es posible que se haya movido o eliminado.",
    privateShareText: "(Por favor contácteme para obtener la contraseña)",
},
inviteFriends:{
    titleBefor: '¡Invitar a tantos amigos como pueda y obtenga  ',
    titleAfter: ' tráfico por cada amigo que haya invitado! ¡Sin límite de cuota!',
    shareEmailTitle: 'Compartir invitación: ',
    shareLinkTitle: 'Compartir enlace de invitación: ',
    emailSend: 'Enviar',
    emailTip: 'Agregar dirección de Email aquí',
    wonMonthFlows: 'Tráfico adicional de por vida que ha ganado este mes: ',
    wonMonthTitle: '¡Tenga la oportunidad de ganar tráfico de datos ILIMITADO DE POR VIDA!',
    lastWinner: 'Último Ganador ',
    winnerInvites: 'Con {num} invitaciones',
    winnerTip: 'Ganar tráfico ILIMITADO DE PRO VIDA',
    statusTitle: 'Su Estado de Compartido',
    successInvites: 'Invitar con éxito este mes: ',
    chanceWin: 'Oportunidad de ganar: ',
    tipsTitle: 'Términos',
    tipsOne: 'Solo los usuarios invitados con un correo electrónico verificado cuentan como una invitación exitosa',
    tipsTwo: 'Sin límite de cuota del tráfico que gana al invitar personas.',
    tipsThird: 'Si ya es un suscriptor de tráfico ilimitado, no puede ganar 2GB con una invitación exitosa, pero su oportunidad de ganar el servicio ilimitado de por vida se duplicará.',
    shareText: 'MultCloud - Transferir y administrar sus archivos de múltiples clouds con una sola aplicación. ¡Únase a MultCloud ahora y obtenga un bono de tráfico de nube a nube de 2GB!',
},
 paySystem:{
    billed:'Facturado a 0,099€/GB por tráfico adicional',
    subCould:'Los suscriptores pueden usar 50GB/5,9€ y 100GB/9,9€ para tráfico de datos adicional si el tráfico de datos no es suficiente',
    limitedMonth:'150GB/Mes',
    limitedTrafficMonth:'150GB Tráfico/Mes',
    unlimitedTraffic:'¡Tráfico Ilimitado de por Vida!',
    foraYear:'Tráfico Ilimitado por un Año',
    noNeedPurchase:'No es necesario comprar tráfico adicional',
    yearlyPayment:'Pago Anual(7,5€/Mes)',
    validityData:'La validez del tráfico de datos que compra es permanente',
    additionalPackage:'Paquete de Tráfico Adicional',
    subscriptmc:'Su Suscripción de MultCloud',
    upgradeMore:'Actualizar a MultCloud Premium para obtener más tráfico de transferencia y beneficios adicionales',
    recommended:'Recomendado',
    toUnlimited:'Actualizar a Ilimitado',
    otherPlan:'Otros Planes',
    moreTraffic:'Comprar Más Tráfico',
    monthlySubscriber:`Usted es un suscriptor trimestral y tiene un tráfico de datos de 150GB para transferir o sincronizar datos entre los servicios de almacenamiento en la nube
    <br> cada mes.`,
   moreDetails:`<a class='add-cloud-link sysLink'>Más detalles sobre los privilegios</a>`,
   dataTraffic:'Uso del tráfico de datos del mes actual',
   cloudTraffic:'Tráfico de Cloud a Cloud',
   buyNow:'Comprar Ahora',
   specialOffer:'Oferta Especial',
   lifetimeFree:'Gratis de por vida',
   unsubscribe:'Cancelar la suscripción',
   includes:'Incluir',
   reSubscription:'Reactivar Suscripción',
   monthTraffic:'Tráfico Ilimitado por un Mes',
   threeMonth:'30GB/Mes',
   monthlyPayment:'Pago Mensual',
   monthlyUnlimited:'Mensual Ilimitado',
   gb:'GB',
   YearlyUnlimited:'Anual Ilimitado',
   YearlyPaymentNine:'Pago Anual(9,9€/Mes)',
   Onetime:'Pago Único',
   twoMonthree:'200GB/Mes x3',
   QuarterlyPayment:'Pago Trimestral(8,3€/Month)',
   fourMOne:'400GB/Mes x12',
   quarterlySubscriber:`Eres un suscriptor trimestral y tienes un tráfico de datos de 200 GB para transferir o sincronizar datos entre el almacenamiento en la nube
   <br>
   servicios todos los meses.`,
   yearlySubscriber:`Eres un suscriptor anual y tienes un tráfico de datos de 400 GB para transferir o sincronizar datos entre el almacenamiento en la nube
   <br>
   servicios cada mes.`,
   expireIn:'Expira en',
   billYearly:'Facturado anualmente',
   billMonthly:'Facturado mensualmente',
   billQuarterly:'Facturado trimestralmente',
   twoMonTrafficthree:'200GB Tráfico/Mes x3',
   fourMTrafficOne:'400GB Tráfico/Mes x12',
   deleteSubAccount:'Tienes que darte de baja para eliminar tu cuenta, ¿estás seguro de hacer esto?',
   payFirst:'Primero debe',
   paybindEmail:`<a class='add-cloud-link sysLink'> vincular su dirección de correo electrónico y verificarla </a>`,
   payEnd:'antes de suscribirse, porque debemos asegurarnos de que pueda recibir con éxito los correos electrónicos importantes sobre su suscripción.',
   yearlyPaymentTxt:'Pago anual',
   quarterlyPaymentTxt:'Pago trimestral',
    //2021-5-20新加
    upUnlimited:'Actualizar a Anual Ilimitado',
    payDiff:'¡Solo paga la diferencia de precio!',
    yearlyUnlimit:'MultCloud (<b>Anual Ilimitado</b>)',
    providesUnlimited:'El plan anual ilimitado proporciona tráfico de datos ilimitado para transferir o sincronizar datos entre servicios de almacenamiento en la nube durante 12 meses.',
    subProduct:'Este es un producto de suscripción con una tarifa de',
    perYear:'por año.',
    cancelSubscription:'Puede cancelar su subscripción en cualquier momento.',
    defaultPayment:'El método de pago predeterminado es',
    anotherPayment:'Si desea utilizar otro método de pago, haga ',
    clickHere:'clic aquí',
    tryAgain:'El pago no se puede realizar por ahora. Verifique su método de pago y reintentarlo.',
    contactPayment:'¿Tiene algún problema con el pago? Por favor contacte <a href="mailto:support@multcloud.com">support@multcloud.com</a> en cualquier momento.',
    Notice:'Noticia',
    beforeBind:'Por favor, vincule su dirección de correo electrónico antes de suscribirse.',
    processorder:'Está procesando la orden',
    eachGbMoney:'0,12€/',
    eachGbMoneyT:'0,10€/',
    payCouponQuartly:'Pago Trimestral(6.63€/Mes)',
    payCouponlimitedYearly:'Pago Anual(5.83€/Mes)',
    payCouponunlimitedYearly:'Pago Anual(7.50€/Mes)',
    payCouponunlimitedYearlyLow:'Pago Anual(6.67€/Mes)',
    tips:'Consejo: si tiene algún problema, no dude en ponerse en contacto con <a href="mailto:support@multcloud.com">support@multcloud.com</a>.',
    monthly:'150GB mensuales',
    //新版付费页面
    payTitle: 'Elija el MultCloud adecuado para usted.',
    limitedData: 'Datos Limitados',
    unlimitedData: 'Datos Ilimitados',
    monthly: 'Mensualmente',
    annually: 'Anualmente',
    save58: 'Ahorre Hasta Un 58%',
    payTip: 'Contacte Con Nuestro Equipo de Ventas',
    limitTips: 'El tráfico de datos no utilizado se acumulará',
    unlimitTips: 'Ya no hay que preocuparse por el límite de datos',
    tips2: 'Si tiene algún problema durante la compra en línea, no dude en ponerse en contacto con nosotros: <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    vipUpgradeTips: 'Esta es la oferta para los usuarios del plan {type}.',
    tabPayScheme: {
        perMonth: 'Pago Mensual',
        perYear: 'Pago Anual',
        perNextYear: 'para el primer año (se renueva a {price})',
        refundDays: 'Días de Garantía de Devolución del Dinero',
        advanced: 'Funciones Avanzadas',
        payPremium: 'Actualice a cualquier plan premium y disfrute de todas las funciones avanzadas que se indican a continuación',
        payUnlimited: 'Actualice a cualquier plan ILIMITADO y disfrute de todas las funciones avanzadas siguientes',
        freeTip1: 'Más Tráfico de Datos Entre Nubes',
        freeTip2: 'Tráfico de datos ILIMITADO de nube a nube',
        freeTip3: 'Transferencia/Sincronización/Copia de Seguridad Programada',
        freeTip4: 'Doble Sincronización',
        freeTip5: '10 Hilos de Transferencia',
        freeTip6: '8 Modos de Sincronización',
        freeTip7: 'Filtro de Archivos',
        freeTip8: 'Servidor de Transferencia VIP',
        freeTip9: 'Asistencia al cliente VIP',
        freeTip10: '5 tareas nube a nube en paralelo',
        freeTip11: 'Conversiones ilimitadas de correos electrónicos',
        freeTipTitle1: 'Los suscriptores pueden tener 2 tareas de sincronización en tiempo real y 2 de sincronización normal (4 en total).',
        freeTipTitle2: 'Hay 10 hilos de transferencia para los abonados y 2 hilos de transferencia para los usuarios gratuitos.',
        freeTipTitle3: 'Sincronización bidireccional y 7 opciones personalizadas en la sincronización unidireccional, admite la sincronización en espejo.',
        freeTipTitle4: 'Configure un filtro para transferir o sincronizar automáticamente archivos con nombres de archivo definidos por el usuario o con determinadas extensiones.',
        freeTipTitle5: 'Los suscriptores pueden ejecutar 5 tareas nube a nube en paralelo, mientras que los usuarios gratuitos pueden ejecutar 1 tarea a la vez.',
        freeTipTitle6: 'Los suscriptores pueden convertir un número ilimitado de correos electrónicos en PDF, mientras que los usuarios gratuitos están limitados a convertir 50 correos electrónicos al mes.',
    },
    nowPayScheme: {
        clearInsCountText: 'Pero la cuota de descarga no utilizada para perfiles de Instagram se borrará.',
        manageYourPlan: 'Gestiona tu suscripción',
        price: 'Precio',
        paymentMethon: 'Método de pago',
        autoRenewal: 'Renovación automática',
        priceVat: 'Incluye {currency}{vatPrice} VAT ({percent}% on {currency}{netPrice}).',
        defaultPayment: '{method}, xxxxxxxxxx{num}.',
        paypalPayment: 'El método de pago por defecto es PayPal.',
        changePayment: 'Cambiar la forma de pago',
        activated: 'Próxima fecha de facturación {time}',
        deactivated: 'Próxima fecha de facturación {time}',
        appleTip: 'Su suscripción actual de {name} fue adquirida en el Apple Store.',
        appleTipId: 'ID de transacción de Apple: {id}.',
        googleTip: 'Sus actuales {name} fueron comprados en Google Play.',
        googleTipId: 'ID de orden de Google Play: {id}.',
        appNextTimeTip: 'La renovación automática está activa y la próxima fecha de facturación es el {time}.',
        appNoSubscribe: 'La función de renovación automática se ha desactivado.',
    },
    // 免费用户弹窗
    freePlanPopup: {
        title_traffic: 'Oops！Insuficiente tráfico de nube a nube',
        title_ins: 'Ha alcanzado el límite de descargas',
        title_pdf: 'Has alcanzado el límite de conversión de correo electrónico a PDF',
        title_modes: 'Modo solo disponible en planes Premium',
        title_remote: 'Has alcanzado el límite de carga remota',
        title_subtasks: 'Has alcanzado el límite para la transferencia de equipo',
        title_scheduled: 'La función de programación es exclusiva para planes premium',
        title_speed: 'Velocidad de transferencia quíntuple exclusiva para premium',
        title_sync: 'Has alcanzado el límite para la sincronización normal',
        title_real: 'Has alcanzado el límite para la sincronización en tiempo real',
        title_filter: 'El filtro de archivos es exclusivo de los planes Premium',
        desc: 'Actualiza para desbloquear TODAS las funciones avanzadas',
        itemTitle_th: 'Características y ventajas',
        itemTitle_traffic: 'Tráfico de nube a nube',
        itemTitle_ins: 'Perfiles Ins para descargar',
        itemTitle_pdf: 'Convertir correo electrónico a PDF',
        itemTitle_modes: 'Modos de sincronización',
        itemTitle_remote: 'Tareas de carga remota en paralelo',
        itemTitle_subtasks: 'Migrar subcuentas entre equipos',
        itemTitle_scheduled: 'Transferencia/Sincronización/Copia de seguridad programada',
        itemTitle_speed: 'Velocidad de transferencia',
        itemTitle_sync: 'Tareas normales de sincronización en paralelo',
        itemTitle_real: 'Tareas de sincronización en tiempo real en paralelo',
        itemTitle_filter: 'Filtro de archivos',
        itemTitle_tran: 'Servidor de transferencia VIP',
        itemTitle_customer: 'Atención al cliente VIP',
        itemTitle_watermark: 'Quitar marca de agua del PDF del correo',
        itemValue_cur: 'Su actual',
        itemValue_free: 'Gratis',
        itemValue_upgrade: 'Actualizar a',
        itemvalue_premium: 'Premium',
        itemvalue_5gb: '5 GB / Mes',
        itemvalue_1profile: '1 Perfil / Mes',
        itemvalue_50emails: '50 Emails / Mes',
        itemvalue_maxUnlimited: 'Máximo Ilimitado',
        itemvalue_unlimited: 'Sin límites',
        button: 'Actualización desde 9,99 €',
    },
    // 套餐的支持项
    supportItem: {
        yourCurPlan: 'Tu plan actual',
        // 第1组
        gb5: '5 GB de tráfico de datos gratuitos al mes',
        gb100: '100 GB de tráfico de datos al mes',
        gb200: '200 GB de tráfico de datos al mes',
        gb1200: '1200 GB de tráfico de datos al año',
        gb2400: '2400GB de tráfico de datos al año',
        gbUnlimitedYear: 'Tráfico de datos ilimitado al año',
        gbUnlimitedLifetime: 'Tráfico de datos ilimitado de por vida',
        gbPackage50: '',
        gbPackage100: '',
        gbGiveAway500: '',
        gbGiveAway200: '',
        ins1: '1 perfil de Ins para descargar al mes',
        ins10: '10 perfiles de Ins para descargar al mes',
        ins20: '20 perfiles de Ins para descargar al mes',
        ins120: '120 perfiles de Ins para descargar al año',
        ins240: '240 perfiles de Ins para descargar al año',
        insPackage50: '',
        insPackage100: '',
        insGiveAway500: '',
        insGiveAway200: '',
        pdf50: 'Convierte 50 correos electrónicos al mes',
        pdfUnlimited: 'Conversiones ilimitadas de correos electrónicos',
        threads2: '2 hilos de transferencia de datos',
        threads10: '10 hilos para la transferencia de datos',
        scheduled: 'Transferencia/sincronización/respaldo programados',
        // 第2组
        acrossClouds: 'Transferencia/sincronización/respaldo entre nubes',
        offline: 'Transferencia/sincronización/copia de seguridad sin conexión',
        subAccounts3: 'Migrar 3 subcuentas entre equipos',
        subAccounts1000: 'Migrar 1000 subcuentas entre equipos',
        highSpeed: 'Transferencia de datos de alta velocidad',
        // 第3组
        syncMode4: '4 modos de sincronización unidireccional/ bidireccional',
        syncMode10: '10 modos de sincronización unidireccional/ bidireccional',
        realSync: 'Sincronización en tiempo real',
        passwordProtected: 'Compartición protegida por contraseña',
        subAccounts: 'Colaboración de subcuentas',
        // 第4组
        cloud30: 'Más de 30  servicios líderes de almacenamiento en la nube',
        unlimitedCloud: 'Añade un número ilimitado de cuentas en la nube',
        singleLog: 'Inicio de sesión único en todas las nubes',
        support365: '24/7/365 apoyo prioritario',
        // 其他
        unlimitedDataTraffic: 'Tráfico de datos de nube a nube ilimitado',
        unlimitedInsProfile: 'Descargas ilimitadas de perfiles Ins',
        unlimitedAllFeatures: 'Todas las funciones Premium',
        // VIP弹窗标题
        vipPopupTitleTraffic: 'Ha consumido todo el tráfico de datos',
        vipPopupDescTraffic: 'Actualizar para desbloquear el tráfico de datos ilimitado',
        vipPopupTitleIns: 'Has consumido todas las descargas de perfiles de Instagram ',
        vipPopupDescIns: 'Actualizar para desbloquear descargas ilimitadas de perfiles Ins',
    },
    //套餐arguments参数翻译
    arguments: {
        //参数名
        title: {
            monthly100GB: '100GB / Mes',
            monthly200GB: '200GB / Mes',
            monthlyUnlimit: 'Datos Ilimitados / Mes',
            yearly1200GB: '1200GB / Año',
            yearly2400GB: '2400GB / Año',
            yearlyUnlimit: 'Anualmente Ilimitado',
            lifetimeUnlimit: 'Ilimitado Por Vida',
            package50GB: '50 GB',
            package100GB: '100 GB',
            giveAway500GB: '500GB',
            giveAway200GB: '200GB',
        },
        tips: {
	        monthly100GB: 'Por ejemplo, sólo ha consumido 50 GB de 100 GB en el primer mes y todavía tendrá 50 GB de tráfico de datos adicionales en el mes siguiente.',
            monthly200GB: 'Por ejemplo, sólo ha consumido 150 GB de 200 GB en el primer mes y todavía tendrá 50 GB de tráfico de datos adicionales en el mes siguiente.',
            monthlyUnlimit: '',
            yearly1200GB: 'Por ejemplo, sólo ha consumido 1000 GB de 1200 GB en el primer año y todavía tendrá 200 GB de tráfico de datos adicionales en el próximo año.',
            yearly2400GB: 'Por ejemplo, sólo ha consumido 2000 GB de 2400 GB en el primer año y aún tendrá 400 GB de tráfico de datos adicionales en el siguiente.',
            yearlyUnlimit: '',
            lifetimeUnlimit: '',
            package50GB: 'Por ejemplo, si sólo ha consumido 20 GB de 50 GB este mes, los 30 GB no utilizados seguirán estando disponibles el mes siguiente.',
            package100GB: 'Por ejemplo, si sólo ha consumido 20 GB de 100 GB este mes, los 80 GB no utilizados seguirán estando disponibles el mes siguiente.',
        }
    },
 },
     //双重验证功能
     twoStepverification:{
        bind:'Enlazar correo electrónico primero',
        addVerify:'Necesita agregar una forma de verificar.',
        phoneNotEmpty:'El número de teléfono no puede estar vacío.',
        addPhone:'Agregar un número de teléfono',
        addAlEmail:'Agregar una dirección de Email alternativa',
        verifySet:'Configuración de verificación',
        addWayVerify:'Agregar una forma de verificar',
        enterEmail:'Introduzca su correo electrónico',
        enterPhone:'Introduzca su número de teléfono',
        enterCode:'Ingrese el código que le enviamos a',
        enterCodeTip:'Por favor, compruebe su carpeta de correo no deseado e informe de que no es spam o añada "no-reply@multcloud.email" a su Lista Blanca.',
        codeExpired:'El código de verificación ha caducado.',
        codeinCorrect:'El código de verificación es incorrecto, verifique el código y reinténtelo.',
        verificationTurnOn:'La verificación en dos pasos está habilitada',
        recoverAccess:'Si necesita recuperar el acceso a su cuenta, este código lo ayudará. Debe anotarlo y guardarlo en un lugar seguro. Recomendamos encarecidamente que no guarde su código de recuperación en un dispositivo.',
        longValid:'Si anteriormente tenía un código de recuperación, ya no es válido. utilice este nuevo código en su lugar.',
        removeAll:'¿Elimina todos los dispositivos de confianza?',
        lostAccess:'Recomendamos hacer esto si ha perdido el acceso a un dispositivo en el que ha confiado',
        removeMethod:'¿Eliminar el método de verificación?',
        removeMethodSure:'¿Está seguro de que desea eliminar el método de verificación? Eliminarlo significa que no podrá usarlo para la verificación.',
        getRecode:'Obtener un código de recuperación',
        emailCode:'Enviar un código por correo electrónico',
        TextCode:'Enviar un código por mensaje',
        useAccount:'Está utilizando una cuenta temporal, conecte su correo electrónico e inténtelo de nuevo.',
        removeTrusted:'Eliminar todos los dispositivos de confianza',
        finish:'Terminar',
        newCode:'Su nuevo código es',
        twoStep:'Verificación de dos pasos',
        twoStepis:'La verificación de dos pasos es',
        on:'Activado',
        off:'Desactivado',
        cancel:'Cancelar',
        toManyCodeSend:'Se envían demasiados códigos',
        verifyIdenti:'Verificar identidad con',
        codeCopied:'¡Código copiado!',
        copyCode:'Código de Copia',
        trustedDevice:'¡Dispositivos de confianza eliminados!',
        phoneValueTips:'Consejos: Por favor, elimine el cero inicial y los espacios, guiones o paréntesis.',
    },
    cloudBackup:{
        cloudBackup:'Respaldo en la nube',
        setUpCloud:'Configurar una tarea de Respaldo en la nube para hacer una copia de segurridad de sus archivos en línea de una nube a otra',
        filesBckupTarget: 'Directorios de destino',
    filesBckup:'Archivos para hacer backup',
        selectSoure:'Haga clic aquí para seleccionar los archivos de origen en la nube que desea respaldar',
        saveBackup:'Ubicación de la copia de seguridad',
        selectTarget:'Haga clic aquí para guardar la nube de destino para guardar la copia de seguridad',
        backupNow:'Hacer Backup Ahora',
        canSelect:'Puede seleccionar un máximo de 10,000 artículos',
        backupFiles:'No puede hacer una copia de seguridad de sus archivos en Google Photos.',
        notSelectEvernoteBackup: 'No puede hacer una copia de seguridad de sus archivos en Evernote.',
      backFlickr:'No puede hacer una copia de seguridad de sus archivos en Flickr.',
        thankSubscrib:'Gracias por suscribirse a nuestro servicio, ahora puede hacer una copia de seguridad de hasta 10 archivos al mismo tiempo.',
        maximunBack:'Ahora puede hacer una copia de seguridad de hasta 2 archivos al mismo tiempo. ¡Actualice a cualquier servicio avanzado por hasta 10!',
        backSuccess:'Hacer backup con éxito',
        backFailure:'Hacer backup fallado',
        successBck:'Realizar una copia de seguridad de todos los archivos con éxito',
        taskCanceled:'La tarea se canceló manualmente',
        notRestore:'No se puede encontrar el archivo para restaurar. Pueden haber sido eliminados.',
        selectVersions:'Seleccionar versiones',
        restoreOptions:'Opciones de recuperación',
        selectFiles:'Seleccione os ficheiros que pretende recuperar.',
        toRestore:'Seleccione um ficheiro para recuperar, por favor.',
        originalLocation:'Local original',
        thankRestore:'Obrigado por subscrever o nosso serviço. Agora pode recuperar 10 ficheiros no máximo em simultâneo.',
        restoreSimult:'Agora pode recuperar 2 ficheiros no máximo em simultâneo. Actualize para qualquer serviço para recuperar um máximo de 10!',
        restoreSuccess:'Recuperar com sucesso',
        restorePartial:'Recuperar com sucesso parcialmente',
        restoreFailure:'Falha de recuperar',
        notRestore:'No se puede encontrar el archivo para restaurar. Pueden haber sido eliminados.',
        backupTime:'Tempo de cópia',
        changedFiles:'Ficheiros alterados',
        deleteVersion:'Está certo de apagar a versão de cópia?',
        deleteFiles:'Apagar os ficheiros nesta versão',
        keepLatest:'Mantener siempre el archivo más reciente',
        overWriteFile:'Sobrescribir el archivo',
        skipFile:'Ignorar el archivo',
        versions:'Versiones',
        backupTask:'Tarea de Copia de Seguridad',
        readdCloud:'Volver a Añadir la Nube',
        selectedCloud:'Algunas de las nubes seleccionadas se añadieron a MultCloud antes de que se lanzara la Copia de Seguridad de la Nube, sugerimos que se vuelvan a añadir las nubes a MultCloud y se intente de nuevo',
        continueAnyway:'Continúa de todos modos',
        selectedHasAdded:'La nube seleccionada fue añadida a MultCloud antes de que se publicara la copia de seguridad de la nube, le sugerimos que vuelva a añadir la nube a MultCloud y lo intente de nuevo',
        failCreate:'Fallo al crear la tarea de copia de seguridad',
        failLoad:'Fallo en la carga',
        pleaseReAdd:'Por favor, vuelve a añadir las nubes a MultCloud',
         alreadyAdd:'Ya has añadido la unidad de nube',
         failRename:'Ha fallado el cambio de nombre, porque no se encuentra la carpeta correspondiente',
         taskRuning:'La tarea se está ejecutando, por favor espere hasta que la tarea termine e inténtelo de nuevo.',
        //2021-08-07添加
        oneBackup:'Solo puede realizar una copia de seguridad o una tarea de restauración al mismo tiempo',
        restoreTask:'Restaurar tarea',
        restoreOriginal:'Restaurar a la ubicación original',
        restoreNewLocation:'Restaurar en la nueva ubicación',
        //2021-08-12添加
        backingUp:'Retrocediendo',
        restoring:'Restaurando',
        restore:'Restaurar',
        backup:'Apoyo',
         //2021-08-17添加
         maxNum:'El número máximo de intem de origen es 1000, seleccione menos elementos. PD Una carpeta completa solo cuenta con un elemento.',
         maxLogs:'Nota: El resultado está truncado. Aquí se muestran hasta 1.000 archivos fallidos.',
         backupDetails:'Detalles de la copia de seguridad',
         keepTwoFile:'Conservar ambos archivos',
         restoreDetails:'Restaurar detalles',
         longerDelete:'Es posible que tarde más tiempo si hay una gran cantidad de archivos para eliminar.',
         notFoundAim:'No se puede encontrar el directorio de destino.',
           //2021-10-20
        backupNotWork:'El servicio de copia de seguridad no funciona',
         //2021-10-28
         backupPartial:'Copia de seguridad con éxito parcial',
         configFile:'(Cargando el archivo de configuración)',
         successRestore:'Éxito en la restauración de todos los archivos.',
         notFind:'No se puede encontrar el archivo de configuración, por favor, compruebe si el archivo de configuración existe y la conexión entre la unidad de la nube y MultCloud es válida.',
        selectRestoreItems:'Por favor, seleccione los archivos que desea restaurar.',
        selectRestoreTotles:'Por favor, seleccione un directorio para restaurar.',
        original: '源云盘',
        inTotalTip: '{count} archivos, {size} en total',
    },
    affiliateProgram: {
        leftTitle: "Conviértase en nuestro afiliado",
        title: "Programa de Afiliación de MultCloud",
        headTips1: "Gana hasta un <span>50%</span> de comisión",
        headTips2: "Inscríbase con unos pocos clics, de forma abusivamente <span>gratuita</span>",
        headTips3: "Sin condiciones adicionales, <span>cualquiera</span> puede ser nuestro afiliado!",
        signUpBtn: "Registre una cuenta de afiliado",
        tips: "Consejos: Si ya es un afiliado en Cleverbridge, por favor <a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\">regístrese </a>.",
        howDoTipsTitle: "Cómo funciona",
        howDoTipsMsg: "Una vez que se haya registrado y haya entrado en nuestro programa de afiliados, podrá encontrar AOMEI International Network Limited en la pestaña \"Campañas - Unirse a la campaña\". Haga clic en ella y confirme su adhesión. Una vez que se haya unido a nuestra campaña, verá todos los productos MultCloud disponibles. Si alguien actualiza MultCloud a través de su enlace de referencia, se le pagará con <span>30%-50%</span> de comisión",
        FAQsTitle: "Preguntas frecuentes del programa de afiliados de MultCloud",
        FAQ1: "¿Cómo funciona el programa de afiliados?",
        answer1: "Una vez que su cliente ha pagado a través de su página de referencia, usted recibirá su pago a principios del mes siguiente",
        FAQ2: "Suena muy bien. ¿Cómo me registro?",
        answer2: "Puede inscribirse haciendo clic en el botón \"Sign up an affiliate account\" de arriba. En pocos pasos tendrá su cuenta de afiliado",
        answerPs2: "Consejos: Una vez que haya iniciado sesión en la consola, podrá encontrar AOMEI International Network Limited en la pestaña \"Campains\". Haga clic en ella y confirme su adhesión",
        FAQ3: "¿Cuánta Comisión recibo?",
        answer3: "La comisión difiere de los diferentes planes de suscripción. Por ejemplo, el porcentaje de comisión para el plan mensual es del 30%, pero para el plan ilimitado de por vida, será del 50%",
        FAQ4: "¿Cómo me pagan?",
        answer4: "Depende de la \"forma de pago\" que haya rellenado. Siempre se le pagará al principio de cada mes",
        answerPs4: "Consejos: No hay límite de cantidad mínima para cada pago",
        anyQuestionTitle: "¿Tiene alguna pregunta?",
        anyQuestionTip: "No dude en ponerse en contacto con <a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
    },
    signUp: {
        pwdTip: "Contraseña (8-16 caracteres)",
        signingUp: "Registrarse. . .",
        tips2: "Al crear una cuenta, usted acepta <a href=\"https://www.multcloud.com/es/terms\" class=\"alink\">los Términos de Servicio <a/>&nbsp;y&nbsp;<a href=\"https://www.multcloud.com/es/policy\" class=\"alink\"> la Política de Privacidad<a/>.",
        emailPushTip: "Al marcar esta casilla, acepta recibir correos electrónicos de MultCloud sobre productos, actualizaciones de servicios, ofertas especiales y eventos. Puede darse de baja en cualquier momento.",
    },
    forgetPwd: {
        title: "¿Ha olvidado su contraseña?",
        tip: "Introduzca su dirección de correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
        sending: "Enviando el mensaje ...",
        btnTxt: "Enviar Correo Electrónico de Restablecimiento",
        tips1: "¿Ha olvidado su dirección de correo electrónico?",
        tips2: " Enviar un correo electrónico a soporte",
        tips3: "y lo localizaremos.",
    },
    balackFriday: {
        lastTip: "¡Actúe ahora para obtener esta oferta!",
        title: "Acceso anticipado al Black Friday y al Cyber Monday para obtener tráfico de datos ilimitado de nube a nube con una rebaja del 70%.",
        titleTip: "¡Date prisa mientras dure nuestro stock！",
    },
    christmas: {
        payTxt: "Venta Navideña",
        popupTitle: "SUPERVENTA DE MULTCLOUD",
        pageTitle: "¡Obtenga Tráfico de Datos ILIMITADO de Nube a Nube de por vida con {num}% DTO.!",
        pageTitle2: "¡Obtenga tráfico de datos ILIMITADO de por vida con un {num}% DTO.!",
        paysysTitle: "¡DATE PRISA, ANTES DE QUE SE ACABE!",
        popupTip1: "Tráfico de Datos ILIMITADO de Nube a Nube",
        popupTip2: "10 Hilos de Transferencia de Datos de Alta Velocidad",
        popupTip2Append: "Hay 10 hilos de transferencia para usuarios premium y 2 hilos de transferencia para usuarios gratuitos",
        popupTip3: "Transferencia/sincronización/Respaldo programado",
        popupTip4: "Sincronización en Tiempo Real Unidireccional y Bidireccional",
        popupTip4Append: "Hay 7 modos de sincronización adicionales para los usuarios premium. Sincronización en espejo soportada",
        saledBtn: "COMPRAR AHORA",
    },
    teamTransfer:{
        teamTransfer:'Transferencia de Equipos',
        transferMultiple:'Transferir varias cuentas de una plataforma en la nube a otra (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Shared Drive).',
        businessCloud:'Si es un administrador de nubes empresariales, puede utilizar esta función para migrar fácilmente todas las cuentas de una nube empresarial a otra. Por ejemplo, cada usuario tendrá una carpeta propia en una plataforma de nube, MultCloud puede emparejar automáticamente las carpetas de dos nubes empresariales diferentes y migrar los archivos de una nube a otra.',
        clickSelect:'Haga clic aquí para seleccionar los servicios en la nube de la empresa de origen que le gustaría transferir.',
        sourceAccount:'Cuentas de Origen',
        targetAccounts:'Cuentas de Destino',
        autoMatch:'Auto-Match',
        likeTransfer:'Haga clic aquí para seleccionar los servicios en la nube para empresas a los que desea transferir.',
        youMust:'Primero debe',
        cloudService:' a?adir un servicio de nube ',
        asAdmin:'empresarial como administrador.',
        combinations:'Auto-Match limpiará las combinaciones actuales, ?está seguro de continuar?',
        nosourceAccount:'No hay cuenta de origen ni cuenta de destino.',
        noAccount:'No hay cuentas para Auto-Match.',
        uploadCSV:'Cargar CSV',
        cleanCurrent :'Cargar CSV limpiará las combinaciones actuales, ?está seguro de continuar?',
        csvFile:'El archivo CSV que cargue debe coincidir con el ',
        csvFormat:'formato .CSV.',
        matchCsv:'La organización no puede coincidir con ninguna combinación del archivo CSV, por favor, compruebe el archivo CSV y vuelva a intentarlo.',
        alreadyAdd:'Ya ha a?adido la combinación de estas dos cuentas.',
        cleanAll:'Está a punto de limpiar todas las combinaciones seleccionadas, ?está seguro de continuar?',
        sure:'Sí, Estoy Seguro',
        allTransferred:'Mantenga todos los archivos transferidos en una carpeta.',
        newTrans:'Iniciar transmisión cuando comience el recorrido.',
        optionActivated:'Si esta opción está activada, todos los archivos transferidos se mantendrán en una carpeta de la nube de destino. Por ejemplo, el directorio de origen es Google Workspace\\simon@multcloud.com, y el directorio de destino es OneDrive for Business\\peter@multcloud.com, todos los archivos de Google Workspace\\simon@multcloud.com se transferirán a OneDrive for Business\\peter@multcloud.com\\simon@multcloud.com cuando esta opción esté activada.',
        newTransTip: 'Tareas admitidas: 1. La fuente debe ser una carpeta 2. La fuente es una unidad en la nube, no un correo electrónico 3. El destino no es una unidad en la nube basada en fotos',
        organizationMigration:'Migración de la organización',
         //jimin新增
         downloadCSV:'Descarga CSV',
         dontShow:'No vuelvas a mostrar esto',
         notSelected:'No se puede seleccionar la unidad compartida de Google Workspace como nube de destino para la migración del equipo.',
         batchMatch:'Coincidencia de lotes',
         sourceCloud:'Añadir nube de origen',
         targetCloud:'Añadir nube de destino',
         subTaskLimit:'Límite de Subtarea',
         freeUsers:'Los usuarios gratuitos pueden crear 3 pares de subtareas en una tarea de transferencia de equipo, por favor actualice a la versión premium y podrá tener 1000 subtareas en una tarea de transferencia de equipo.',
         mostTeamTransfer:'3 subtareas como máximo en una transferencia de equipo',
         substasksMost:'1000 subtareas en una transferencia de equipo',
         mostTasks:'El número de subtareas puede ser de 1000 como máximo.',
         timePassed:'El tiempo que fijó ya ha pasado.',
    },
    shareTransfers: {
        logoMsg: '<span class="sf-logo-name">Transferencia de</span> <span class="sf-logo-first">MultCloud</span>',
        addFiles: 'Añadir archivos desde las nubes',
        trnsfering: 'Transfiriendo ...',
        sendingFile: 'Enviar {num} archivo(s)',
        sendingSize: '{num} de {all}',
        sendingTip: 'Se está creando el enlace de transferencia, por favor espere.',
        cancelTransfer: '¿Cancelar esta transferencia?',
        createdTransfer: '¡Transferencia creada!',
        createShare: 'Crear Transferencia',
        signTitleByTransfer: 'Inicie sesión en Multcloud para continuar',
        signupTitleByTransfer: 'Regístrese en Multcloud para continuar',
        transferTitle: 'Título',
        transferDescription: 'Descripción',
        addFileTip: '{num} archivo(s) añadido(s)',
        titleErrMsg: 'El título no debe tener más de 128 caracteres.',
        desErrMsg: 'La descripción no debe tener más de 512 caracteres.',
        folder: 'Carpeta',
    },
    summerSale: {
        titleTip: 'Hola Verano',
        titleTip2: 'Obtenga tráfico de datos ILIMITADO de nube a nube y gestione todos sus recuerdos de verano sin esfuerzo a un precio increíble.',
        bottomTip: '- MEJOR OFERTA DE LA TEMPORADA –',
    },
    halloweenSale: {
        titleTip2: 'Ahorra hasta un 70% en No Hay Trucos, ¡Sólo Regálate tráfico de datos ilimitado de nube a nube! ',
        bottomTip: '¡Apresúrate! Antes de que se acabe.',
    },
    newYear: {
        payTxt: "REBAJAS DE AÑO NUEVO",
        titleTip: '¡Celebre el Año Nuevo con un descuento del 70% en tráfico de datos ILIMITADO de nube a nube!',
        bottomTip: '¡Date prisa! Antes de que desaparezca.',
    },
    backToSchool: {
        titleTip2: 'Obtén tráfico de datos ILIMITADO de nube a nube y gestiona todos tus recuerdos escolares a un precio increíble.',
        bottomTip: '- MEJOR OFERTA DE LA TEMPORADA –',
    },
    blackFriday: {
        titleTip: 'Obtenga un 70% de descuento en tráfico de datos ILIMITADO de nube a nube.',
        bottomTip: '¡Date prisa! Antes de que desaparezca.',
    },
    xmas: {
        titleTip: 'Disfrute de un descuento festivo del 70% en tráfico de datos ILIMITADO de nube a nube estas Navidades.',
        bottomTip: '¡Date prisa! Antes de que desaparezca.',
    },
    license: {
        codeTitle: 'Introducir licencia',
        codeTipTitle: 'Introduzca el código de licencia',
        codeTipText: 'Si tiene un código de licencia, puede utilizarlo para activar el servicio Premium.',
        codeTipTextVip: 'Si tiene un código de licencia, puede utilizarlo para actualizar un servicio avanzado.',
        codeFooter: 'Si necesita ayuda, no dude en ponerse en contacto con: ',
        showTitle: 'Código de licencia',
        showTip: 'El código de licencia es:',
        codeSucTitle: '¡Servicio Premium activado',
        codeSucTip: '¡Servicio Premium activado!',
    },
    filters: {
        taskList: {
            typeName: 'Tipo',
            type: {
                all: 'Lista completa',
                copy: 'Tareas temp',
                transfer: 'Transferencia de Cloud',
                sync: 'Sincronización de Cloud',
                backup: 'Respaldo en la nube',
                business: 'Transferencia de Equipos',
                remoteUpload: 'Descarga Offline',
                emailMigration: 'Migración de Email',
                restore: 'Restauración desde la nube',
            },
            statusName: 'Estado',
            status: {
                all: 'Todos los estados',
                preset: 'Preconfigurado',
                running: 'En ejecución',
                success: 'Éxito',
                patial: 'Éxito parcial',
                failed: 'Fallido',
                canceled: 'Cancelado',
            },
            dateName: 'Fecha',
            date: {
                all: 'Todo el tiempo',
                today: 'Hoy',
                latestWeek: 'Última semana',
                latestMonth: 'Último mes',
                customDate: 'Fecha personalizada',
            },
        }
    },
    schedule: {
        week1: 'Dom',
        week2: 'Lun',
        week3: 'Mar',
        week4: 'Miér',
        week5: 'Jue',
        week6: 'Vie',
        week7: 'Sáb',
    },
    inputTab: {
        filterMessage: 'Pulsa Enter para añadir la extensión de archivo',
    }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/spanish.js